// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../icomoon/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Assistant-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Assistant-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Assistant-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Assistant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Assistant-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Assistant-ExtraBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Assistant-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Assistant-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Assistant-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Assistant-ExtraBold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Assistant-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Assistant-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Assistant-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Assistant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Assistant-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Assistant-ExtraLight.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Assistant-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Assistant-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Assistant-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Assistant-ExtraLight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Assistant-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Assistant-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Assistant-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Assistant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Assistant-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Assistant-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Assistant-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Assistant-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/Assistant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/Assistant-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/Assistant-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/Assistant-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/Assistant-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/Assistant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/Assistant-SemiBold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#Assistant-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#Assistant-ExtraBold" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#Assistant-Bold" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#Assistant-ExtraLight" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#Assistant-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#Assistant-Light" });
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___, { hash: "#Assistant-SemiBold" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Assistant';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Assistant';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Assistant';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg");
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Assistant';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg");
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Assistant';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Assistant';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Assistant';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("svg");
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    font-size: 16px;
}

body {
    font-family: "Assistant", sans-serif;
    background: #fff;
    color: #364048;
    /*overflow: hidden;*/
}

.wrapper {
    width: 100%;
    /*overflow: hidden;*/
    margin: 0 auto;
    position: relative;
    background: #F0F0F3;
}

.row {
    display: flex;
    flex-wrap: wrap;
}

.clear {
    clear: both;
}

/* width */
::-webkit-scrollbar {
    width: 8px;
    display: block;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 4px 4px 4px #AEAEC033;
    border-radius: 67px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 8px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: transparent;
}

.card__settings, .card__risk__alert, .card__product__unstacked, .card__product__stake, .to__top, .layout__list,
.layout__grid, .wallet__addresses__top__right__btn, .card__product__stake__amount__max, .add__defi__item {
    transition: all 0.4s;
}

.card__settings:hover, .card__risk__alert:hover, .card__product__unstacked:hover, .card__product__stake:hover, .to__top:hover, .layout__list:hover,
.layout__grid:hover, .wallet__addresses__top__right__btn:hover, .card__product__stake__amount__max:hover, .add__defi__item:hover {
    box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;
}

.wallet__type__btn, .limit__block__top {
    transition: all 0.4s;
}

.wallet__type__btn:hover, .limit__block__top:hover {
    box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);
}

.wallet__type__save, .card__product__stake__amount__confirm, .password__change__btn, .login__btn {
    transition: all 0.4s;
}

.wallet__type__save:hover, .card__product__stake__amount__confirm:hover, .password__change__btn:hover, .login__btn:hover {
    background: #1762A2;
}

.card__risk__alert.active {
    transition: all 0.4s;
    box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;
}

.limit__block__top.active {
    transition: all 0.4s;
    box-shadow: 3px 3px 3px #AEAEC033, -3px -3px 3px #FFFFFFB2;
}

.align-items-center {
    align-items: center;
}

.dropdown {
    position: relative;
    width: 272px;
}

.dropdown.open .dropdown__selected {
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
}

.dropdown.open .dropdown__selected .dropdown__arrow {
    transform: rotate(-180deg);
}

.dropdown.open .dropdown__body {
    display: block;
}

.dropdown__selected {
    height: 48px;
    width: 100%;
    background: #EDEDEF;
    box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 20px;
    position: relative;
    z-index: 2;
    cursor: pointer;
}

.dropdown__arrow {
    display: flex;
    right: 25px;
    position: absolute;
}

.dropdown__body {
    background: #F0F0F3;
    box-shadow: 0 5px 15px #38465241;
    border-radius: 0 0 20px 20px;
    padding: 35px 16px 16px;
    position: absolute;
    width: 100%;
    z-index: 1;
    top: 25px;
    display: none;
}

.dropdown__copy {
    width: 100%;
    border-radius: 80px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #A9B6C1;
    font-weight: 600;
    font-size: 20px;
    position: relative;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
}

.dropdown__copy__icon__wrapper {
    width: 32px;
    height: 32px;
    box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
}

.dropdown__sub {
    margin-top: 16px;
    position: relative;
    width: 248px;
}

.dropdown__sub.open .dropdown__sub__selected {
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
}

.dropdown__sub.open .dropdown__sub__selected .dropdown__arrow {
    transform: rotate(-180deg);
}

.dropdown__sub.open .dropdown__sub__body {
    display: block;
}

.dropdown__sub__selected {
    height: 48px;
    width: 100%;
    background: #EDEDEF;
    box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 20px;
    position: relative;
    z-index: 2;
    cursor: pointer;
}

.dropdown__sub__body {
    position: absolute;
    box-shadow: 0 5px 15px #38465241;
    border-radius: 0 0 25px 25px;
    background: #F0F0F3;
    width: 100%;
    top: 25px;
    padding: 35px 16px 16px;
    display: none;
}

.dropdown__sub__item {
    color: #364048;
    font-weight: 600;
    font-size: 20px;
    padding: 13px 0;
    border-bottom: 1px solid #A9B6C1;
}

.dropdown__sub__item:last-child {
    border-bottom: 0;
    padding-bottom: 3px;
}

.dropdown__sub__item:first-child {
    padding-top: 0;
}

.modal__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    z-index: 999;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 105px;
}

.modal {
    width: 992px;
    border-radius: 20px;
    box-shadow: 0 5px 15px 0 rgba(56, 70, 82, 0.25);
    background-color: #f0f0f3;
    padding: 24px 24px 0;
    height: min-content;
}

.modal__header {
    display: flex;
    position: relative;
    align-items: center;
    padding-left: 24px;
    padding-right: 24px;
}

.card {
    max-width: 312px;
    width: 100%;
    height: 488px;
    background: #F0F0F3;
    box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px #AEAEC067;
    border-radius: 24px;
    margin-right: 40px;
    margin-bottom: 40px;
    padding: 24px;
    position: relative;
}

.card.chart__open {
    z-index: 2;
}

.card.aside__card__big {
    margin: 49px auto 8px;
    padding: 0;
    box-shadow: unset;
}

.card.aside__card__big .card__wallet__row {
    background-color: transparent;
}

.card.aside__card__big .card__title {
    font-size: 18px;
    text-align: center;
    max-width: 225px;
    margin: 0 auto;
}

.card.aside__card__big .card__wallet__usd {
    font-size: 20px;
    color: #364048;
    font-weight: 700;
}

.card.aside__card__big .card__product__number.cold {
    color: #4DC7B5;
}

.card.aside__card__big .card__product__number.cold.empty {
    color: #889096;
}

.card.aside__card__big .card__product__number.hold {
    color: #EFB661;
}

.card.aside__card__big .card__product__number.hold.empty {
    color: #889096;
}

.card.aside__card__big .card__product__number.risky {
    color: #F27281;
}

.card.aside__card__big .card__product__number.risky.empty {
    color: #889096;
}

.card .add__wallet {
    display: none;
}

.card.new .new__layer {
    border-radius: 24px;
    background: rgba(240, 240, 243, 0.7);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    position: absolute;
}

.card.new .add__wallet {
    background: #F0F0F3;
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;
    width: 136px;
    height: 136px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
}

.card.new .add__wallet .save__text {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    opacity: 0;
    visibility: hidden;
    color: #ffffff;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: normal;
    max-width: max-content;
    max-height: max-content;
}

.card.new .add__wallet .plus__wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
}

.card.new .add__wallet .plus__wrapper span {
    width: 30px;
    height: 5px;
    background: #F0F0F3;
    border-radius: 2px;
    position: absolute;
}

.card.new .add__wallet .plus__wrapper span:nth-child(2) {
    transform: rotate(90deg);
}

.card.new .add__wallet.new .plus__wrapper {
    visibility: visible;
    opacity: 1;
}

.card.new .add__wallet.save {
    top: 288px;
}

.card.new .add__wallet.save .plus__wrapper {
    position: absolute;
    visibility: hidden;
    opacity: 0;
}

.card.new .add__wallet.save .save__text {
    opacity: 1;
    visibility: visible;
}

.card.new .add__wallet .add__wallet__btn__bg {
    background: #1762A2;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;
    position: relative;
}

.card.trash .trash__layer {
    border-radius: 24px;
    background: rgba(240, 240, 243, 0.7);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    position: absolute;
}

.card.trash .trash__wallet {
    background: #F0F0F3;
    box-shadow: -8px -8px 24px #FFFFFF, 10px 10px 30px #AEAEC067;
    width: 136px;
    height: 136px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
}

.card.trash .unstacking {
    display: none;
}

.card.trash .trash__wallet__icon {
    width: 44px;
    height: 48px;
}

.card.trash .card__settings {
    opacity: 0;
    visibility: hidden;
}

.card.new__defi .card__risk {
    margin-top: 60px;
}

.card.empty .card__nft__img,
.card.empty .card__risk__range,
.card.empty .unstacking {
    opacity: 0;
    visibility: hidden;
}

.card.empty .card__product__unstacked,
.card.empty .card__product__stake,
.card.empty .card__risk__chart__number__of,
.card.empty .card__risk__chart__number,
.card.empty .card__risk__alert__title,
.card.empty .card__risk__alert__number,
.card.empty .card__price {
    color: #C4C4C4;
}

.card.empty .card__risk__chart__min {
    box-shadow: inset 0 3px 6px #00000029;
    border-color: transparent;
    width: 130px;
    height: 130px;
    position: relative;
}

.card.empty .card__risk__chart__min:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: inline-flex;
    margin: 0 auto;
    width: 9px;
    height: 9px;
    background: #c3c3c3;
    border-radius: 50%;
}

.card.empty .card__wallet__row {
    opacity: 0;
    visibility: hidden;
}

.card.empty .add__wallet {
    background: #F0F0F3;
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;
    width: 136px;
    height: 136px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
}

.card.empty .add__wallet .save__text {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    opacity: 0;
    visibility: hidden;
    color: #ffffff;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: normal;
    max-width: max-content;
    max-height: max-content;
}

.card.empty .add__wallet .plus__wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
}

.card.empty .add__wallet .plus__wrapper span {
    width: 30px;
    height: 5px;
    background: #F0F0F3;
    border-radius: 2px;
    position: absolute;
}

.card.empty .add__wallet .plus__wrapper span:nth-child(2) {
    transform: rotate(90deg);
}

.card.empty .add__wallet.new .plus__wrapper {
    visibility: visible;
    opacity: 1;
}

.card.empty .add__wallet.save {
    top: 298px;
}

.card.empty .add__wallet.save .plus__wrapper {
    position: absolute;
    visibility: hidden;
    opacity: 0;
}

.card.empty .add__wallet.save .save__text {
    opacity: 1;
    visibility: visible;
}

.card.empty .add__wallet .add__wallet__btn__bg {
    background: #1762A2;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;
    position: relative;
}

.card.cold .card__risk__chart__min {
    border-color: #4DC7B5;
}

.card.cold .card__product__number,
.card.cold .card__risk__chart__number__of,
.card.cold .card__risk__chart__number {
    color: #4DC7B5;
}

.card.cold .card__product__number.empty,
.card.cold .card__risk__chart__number__of.empty,
.card.cold .card__risk__chart__number.empty {
    color: #889096;
}

.card.cold .card__risk__info:hover {
    background: #4DC7B5;
    color: #ffffff;
}

.card.hold .card__risk__chart__min {
    border-color: #EFB661;
}

.card.hold .card__product__number,
.card.hold .card__risk__chart__number__of,
.card.hold .card__risk__chart__number {
    color: #EFB661;
}

.card.hold .card__product__number.empty,
.card.hold .card__risk__chart__number__of.empty,
.card.hold .card__risk__chart__number.empty {
    color: #889096;
}

.card.hold .card__risk__info:hover {
    background: #EFB661;
    color: #ffffff;
}

.card.risky .card__risk__chart__min {
    border-color: #F27281;
}

.card.risky .card__product__number,
.card.risky .card__risk__chart__number__of,
.card.risky .card__risk__chart__number {
    color: #F27281;
}

.card.risky .card__product__number.empty,
.card.risky .card__risk__chart__number__of.empty,
.card.risky .card__risk__chart__number.empty {
    color: #889096;
}

.card.risky .card__risk__info:hover {
    background: #F27281;
    color: #ffffff;
}

.card__header {
    margin-bottom: 8px;
}

.card__header .row {
    align-items: flex-start;
    justify-content: space-between;
}

.card__settings {
    border: 0;
    width: 24px;
    height: 24px;
    background: #F0F0F3;
    border-radius: 50%;
    box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px #AEAEC067;
    color: #364048;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.card__title {
    font-weight: 600;
    font-size: 18px;
    color: #364048;
    text-align: center;
}

.card__title span {
    display: block;
}

.card__close {
    width: 16px;
    height: 16px;
    display: inline-flex;
    border: 0;
    background-color: transparent;
    position: relative;
}

.card__close span {
    height: 100%;
    position: absolute;
    top: 0;
    cursor: pointer;
    width: 2px;
    background: #364048;
    transform: rotate(45deg);
}

.card__close span:nth-child(2) {
    transform: rotate(-45deg);
}

.card__price {
    height: 48px;
    width: 100%;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4DC7B5;
    font-size: 18px;
    line-height: 23px;
    font-weight: bold;
    margin-bottom: 16px;
}

.card__wallet {
    width: 100%;
    height: 108px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 17px;
    background: rgba(240, 240, 243, 0.05);
    overflow-x: hidden;
    overflow-y: auto;
    margin-bottom: 34px;
}

.card__wallet::-webkit-scrollbar-track {
    display: none;
}

.card__wallet::-webkit-scrollbar-thumb {
    display: none;
}

.card__wallet__row {
    display: flex;
    justify-content: space-between;
    height: 35px;
    padding: 0 15px;
    align-items: center;
    /*overflow: hidden;*/
    width: 100%;
    transition: all 0.4s;
}

.card__wallet__row:nth-child(2n + 1) {
    background: rgba(132, 132, 132, 0.05);
}

.card__wallet__usd, .card__wallet__rates {
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    color: #364049;
}

.card__wallet__usd {
    color: #889096;
    font-weight: 400;
}

.card__risk {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.card__risk__title {
    color: #717679;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 15px;
}

.card__risk__chart {
    width: 144px;
    height: 144px;
    box-shadow: inset 6px 6px 6px #AEAEC033, inset -6px -6px 6px #FFFFFFB2;
    background: #F0F0F3;
    border-radius: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card__risk__chart__min {
    width: 108px;
    height: 108px;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-width: 10px;
    border-style: solid;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.card__risk__chart__number {
    font-weight: bold;
    font-size: 26px;
    line-height: 34px;
}

.card__risk__chart__number__of {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
}

.card__risk__alert {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    background: #F0F0F3;
    box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;
    position: absolute;
    right: 0;
    top: 19px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    transition: all 0.4s;
    cursor: pointer;
}

.card__risk__alert__title {
    color: #889096;
    font-size: 18px;
    line-height: 18px;
}

.card__risk__alert__number {
    color: #f27281;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
}

.card__risk__info {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: #EBEBEB;
    border-radius: 50%;
    color: #cbcbcb;
    font-size: 12px;
    position: absolute;
    bottom: -10px;
    left: 48px;
    box-shadow: -2px -2px 2px #FFFFFF, 2px 2px 2px #9191A567;
    transition: all 0.4s;
    cursor: pointer;
}

.card__product__row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 5px;
    padding-bottom: 5px;
    position: relative;
    width: 100%;
}

.card__product__row:after {
    content: "";
    width: 100%;
    border-radius: 67px;
    height: 3px;
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;
}

.card__product__row .product__row__dropdown {
    width: 100%;
    background: #F0F0F3;
    box-shadow: 0 8px 15px #00000027, -8px -8px 24px #FFFFFF;
    border-radius: 0 0 8px 8px;
    position: absolute;
    opacity: 0;
    visibility: hidden;
    transition: all 0.4s;
    padding: 4px 16px;
    z-index: 3;
    top: 30px;
    left: 0;
}

.card__product__row .product__row__dropdown .product__row__dropdown__item {
    color: #889096;
    font-size: 18px;
    line-height: 23px;
    width: 100%;
    border-bottom: 1px solid #c9c9ca;
    text-transform: uppercase;
    padding: 5px 0;
    cursor: pointer;
}

.card__product__row .product__row__dropdown .product__row__dropdown__item:last-child {
    border-bottom: 0;
}

.card__product__row .product__row__dropdown.open {
    visibility: visible;
    opacity: 1;
}

.card__product__title {
    color: #889096;
    font-size: 18px;
    line-height: 23px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.4s;
}

.card__product__number {
    font-size: 24px;
    line-height: 32px;
    text-shadow: 0 3px 6px #4DC7B534;
    font-weight: bold;
}

.card__product__unstacked, .card__product__stake {
    background: #F0F0F3;
    box-shadow: inset -5px -5px 5px #7F7FAD21, -5px -5px 15px #FFFFFF, inset 5px 5px 5px #FFFFFF, 5px 5px 15px #8E8EB533;
    border-radius: 20px;
    cursor: pointer;
    width: 112px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    outline: none;
    font-size: 18px;
    line-height: 22px;
}

.card__product__stake__block {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
}

.card__product__unstacked {
    color: #BA8557;
}

.card__product__stake {
    color: #5781BA;
}

.card__risk__range {
    width: 8px;
    height: 176px;
    /*box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;*/
    border-radius: 88px;
    background: #F0F0F3;
    position: absolute;
    left: 5px;
    top: 0;
    display: none;
}

.card__risk__range.active {
    display: block;
}

.card__risk__range__bg {
    width: 100%;
    height: 50%;
    background: #F27281;
    box-shadow: inset 3px 3px 3px #40405053;
    border-radius: 0 0 20px 20px;
    position: absolute;
    bottom: 0;
}

.card__risk__range__btn {
    width: 24px;
    height: 24px;
    background: #F0F0F3;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #36364D67;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: -8px;
    cursor: pointer;
}

.card__risk__range__btn__min {
    background: #F27281;
    width: 16px;
    display: flex;
    height: 16px;
    border-radius: 50%;
    box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);
}

.card__risk__range__hr {
    width: 176px;
    height: 8px;
    box-shadow: inset 3px 3px 3px #AEAEC033, inset -3px -3px 3px #FFFFFFB2;
    border-radius: 88px;
    background: #F0F0F3;
    position: absolute;
    left: 5px;
    top: 0;
    display: none;
}

.card__risk__range__hr.active {
    display: block;
}

.card__risk__range__bg__hr {
    width: 50%;
    height: 100%;
    background: #F27281;
    box-shadow: inset 3px 3px 3px #40405053;
    border-radius: 20px 0 0 20px;
    position: absolute;
    left: 0;
}

.card__risk__range__btn__hr {
    width: 24px;
    height: 24px;
    background: #F0F0F3;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #36364D67;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: absolute;
    top: -8px;
    left: 50%;
    cursor: pointer;
}

.card__risk__range__btn__hr__min {
    background: #F27281;
    width: 16px;
    display: flex;
    height: 16px;
    border-radius: 50%;
    box-shadow: inset 2px 2px 2px rgba(54, 54, 70, 0.6), inset -2px -2px 2px rgba(255, 255, 255, 0.6);
}

.card__nft__wrapper {
    width: 264px;
    height: 192px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 17px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card__nft__img {
    width: 232px;
    height: 160px;
    border-radius: 17px;
}

.card__list {
    width: 344px;
    height: 88px;
    background: #F0F0F3;
    box-shadow: -8px -8px 24px #FFFFFF, 8px 8px 24px #AEAEC067;
    border-radius: 24px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 16px;
    margin-right: 80px;
    margin-bottom: 48px;
    cursor: pointer;
}

.list.active .card__list:not(.active) {
    opacity: 0.5;
    -webkit-user-select: none;
            user-select: none;
    cursor: default;
}

.card__list.cold .card__risk__chart__list__min {
    border-color: #4DC7B5;
}

.card__list.cold .card__risk__chart__list__number {
    color: #4DC7B5;
}

.card__list.cold .card__risk__chart__list__number.empty {
    color: #889096;
}

.card__list.hold .card__risk__chart__list__min {
    border-color: #EFB661;
}

.card__list.hold .card__risk__chart__list__number {
    color: #EFB661;
}

.card__list.hold .card__risk__chart__list__number.empty {
    color: #889096;
}

.card__list.risky .card__risk__chart__list__min {
    border-color: #F27281;
}

.card__list.risky .card__risk__chart__list__number {
    color: #F27281;
}

.card__list.risky .card__risk__chart__list__number.empty {
    color: #889096;
}

.card__list__percent {
    display: flex;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    font-size: 16px;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
}

.card__risk__chart__list {
    width: 104px;
    height: 104px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F0F0F3;
    position: absolute;
    right: -52px;
    top: -10px;
    border-radius: 50%;
    box-shadow: inset 6px 6px 6px #AEAEC033, inset -6px -6px 6px #FFFFFFB2;
}

.card__risk__chart__list__min {
    width: 56px;
    height: 56px;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    border-width: 8px;
    border-style: solid;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
}

.card__risk__chart__list__number {
    font-size: 24px;
    font-weight: bold;
}

.card__list__anchor,
.card__list__title {
    font-weight: 600;
    font-size: 18px;
    color: #364048;
}

.card__has__chart {
    position: relative;
    z-index: 1;
}

.card__chart__wrapper {
    width: 736px;
    height: 530px;
    background: #f0f0f3;
    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);
    border-radius: 24px;
    position: absolute;
    padding: 25px 40px 32px 72px;
    transition: opacity 0.4s;
    margin: auto;
    position: relative;
}
.chart__open__btn{
    cursor: pointer;
}


.card__chart {
    width: 624px;
    height: 384px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 24px;
}

.card__chart__title {
    font-weight: 600;
    font-size: 18px;
    color: #364048;
    margin-right: 25px;
}

.card__chart__header {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
}

.check__wrapper {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-right: 24px;
    cursor: pointer;
}

.check__wrapper:last-child {
    margin-right: 0;
}

.check__wrapper [type="checkbox"] {
    display: none;
}

.check__wrapper [type="checkbox"]:checked ~ .checkbox__label .check__icon {
    opacity: 1;
    visibility: visible;
}

.check__wrapper.gray .checkbox__box {
    background: #C9CEFF;
}

.check__wrapper.blue .checkbox__box {
    background: #97EAEA;
}

.check__wrapper.yellow .checkbox__box {
    background: #F0DC8B;
}

.check__wrapper .checkbox__box {
    width: 24px;
    height: 24px;
    box-shadow: inset 2px 2px 2px #AEAEC033, inset -2px -2px 2px #FFFFFFB2;
    border-radius: 6px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.check__wrapper .checkbox__box .check__icon {
    opacity: 0;
    visibility: hidden;
    transition: all 0.4s;
    width: 12px;
    height: 12px;
}

.check__wrapper .checkbox__text {
    display: inline-flex;
    margin-left: 7px;
    cursor: pointer;
}

.check__wrapper .checkbox__label {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #889096;
}

.check__wrapper__all {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
}

.card__chart__dropdown {
    width: 72px;
    position: relative;
    cursor: pointer;
}

.card__chart__dropdown__selected {
    font-size: 14px;
    line-height: 23px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #2267A4;
    position: relative;
}

.card__chart__dropdown__selected:after {
    content: "";
    position: absolute;
    width: 72px;
    height: 3px;
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;
    border-radius: 67px;
    opacity: 0.93;
    bottom: -2px;
}

.card__chart__dropdown__selected .card__chart__dropdown__selected__arrow {
    width: 7px;
    height: 7px;
    border-bottom: 1px solid #2267A4;
    border-right: 1px solid #2267A4;
    transform: rotate(45deg);
}

.card__chart__dropdown__block {
    background: #F0F0F3;
    width: 100%;
    padding: 4px 0 4px 7px;
    box-shadow: 0 8px 15px #00000027;
    border-radius: 0 0 8px 8px;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 25px;

    transition: opacity 0.4s;
}

/* .open .card__chart__dropdown__block {
    opacity: 1;
    visibility: visible;
} */

.card__chart__dropdown__list {
    color: #889096;
    font-size: 14px;
    line-height: 23px;
}

.header {
    height: 80px;
    min-height: 80px;
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFF80;
    width: 100%;
    background: #F0F0F3;
    padding: 0 25px 0 120px;
    position: relative;
    z-index: 1;
    transition: all 0.4s;
}

.header.open {
    padding-left: 296px;
}

.header .row {
    height: 100%;
    align-items: center;
}

.header__title {
    font-weight: 700;
    line-height: 27px;
    font-size: 22px;
    transition: all 0.4s;
}

.open .header__title {
    font-size: 26px;
    line-height: 32px;
}

.header__right {
    display: flex;
    margin-left: auto;
    align-items: center;
    height: 100%;
}

.notification {
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification__btn {
    border: 0;
    background-color: transparent;
    cursor: pointer;
    font-size: 17px;
    position: relative;
    color: #868e95;
}

.notification__status {
    background: #F5B452;
    box-shadow: 0 3px 6px #00000040;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    top: -5px;
    right: -2px;
}

.user {
    height: 48px;
    width: 145px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 40px;
    flex-wrap: wrap;
    transition: all 0.4s;
    cursor: pointer;
}

.user.open {
    border-radius: 24px;
    width: 145px;
    height: 136px;
    background: #F0F0F3;
    box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px #AEAEC067;
    align-self: flex-start;
}

.user.open .log__out {
    display: inline-flex;
}

.user.open:before, .user.open:after {
    display: none;
}

.user:before, .user:after {
    content: "";
    box-shadow: inset 10px 10px 10px #AEAEC033;
    border-radius: 67px;
    height: 100%;
    width: 3px;
    position: absolute;
    top: 0;
}

.user:before {
    left: 0;
}

.user:after {
    right: 0;
}

.user__avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 20px;
}

.user__name {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    max-width: 32px;
}

.user .log__out {
    width: 100%;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-top: 14px;
    margin-bottom: 10px;
    display: none;
}

.user .log__out:before {
    position: absolute;
    top: 0;
    content: "";
    width: 112px;
    height: 4px;
    box-shadow: inset 2px 2px 2px #AEAEC033, inset -2px -2px 2px #FFFFFFB2;
    border-radius: 67px;
}

.user .log__out__icon {
    margin-right: 8px;
}

.setting__btn {
    border: 0;
    cursor: pointer;
    color: #868e95;
    font-size: 16px;
}

.logo {
    width: 32px;
    height: 36px;
    margin-top: 24px;
    margin-bottom: 45px;
    position: relative;
}

.logo__img {
    width: 100%;
    height: 100%;
}

.logo__img__big {
    width: 0;
    height: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    transition: all 0.4s;
}

.nav {
    width: 96px;
    height: 100vh;
    background: #F0F0F3;
    box-shadow: inset 0 3px 6px #00000029, 3px 0 6px #43607926;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 3;
    padding-right: 10px;
    transition: all 0.4s;
}

.nav.open {
    width: 272px;
}

.nav.open .logo {
    width: 200px;
}

.nav.open .logo__img {
    display: none;
}

.nav.open .logo__img__big {
    display: inline-block;
    width: 100%;
    height: 100%;
}

.nav.open .nav__link {
    width: 208px;
}

.nav.open .nav__link .nav__text {
    font-size: 20px;
    position: relative;
    opacity: 1;
    visibility: visible;
    color: #364048;
}

.nav__block {
    list-style-type: none;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.nav__list {
    margin-bottom: 10px;
}

.nav__list.trash {
    margin-top: auto;
}

.nav__link {
    font-size: 30px;
    text-decoration: none;
    padding: 16px;
    display: inline-flex;
    color: #7e92a3;
    transition: all 0.4s;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
}

.nav__link:hover, .nav__link.active {
    background: #F0F0F3;
    box-shadow: inset -3px -3px 3px #FFFFFFB2, inset 0px 3px 6px #00000029, 3px 0px 6px #43607926;
    border-radius: 12px;
    color: #2267a4;
}

.nav__link:hover .trash__icon, .nav__link.active .trash__icon {
    filter: brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(5984%) hue-rotate(169deg) brightness(102%) contrast(91%);
}

.nav__link i {
    width: 30px;
    position: relative;
    z-index: 1;
}

.nav__link .nav__text {
    display: inline-flex;
    color: transparent;
    margin-right: auto;
    margin-left: 15px;
    white-space: nowrap;
    font-size: 0;
    transition: font-size 0.2s, visibility 0.4s, opacity 0.4s;
    opacity: 0;
    visibility: hidden;
    position: absolute;
}

.trash__icon {
    height: 25px;
}

.menu__open {
    background: #F0F0F3;
    box-shadow: inset 0px 3px 6px #00000029, 3px 0px 6px #43607926;
    width: 106px;
    height: 106px;
    position: absolute;
    border-radius: 50%;
    top: 50%;
    right: -53px;
    clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
    transition: all 0.4s;
}

.menu__open.open .menu__open__btn {
    transform: rotate(180deg);
}

.menu__open__btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #F0F0F3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;
    cursor: pointer;
    position: absolute;
    margin-top: auto;
    margin-bottom: auto;
    top: 0;
    bottom: 0;
    left: 10px;
    transition: all 0.4s;
}

.main {
    height: calc(100vh - 56px);
    /*overflow: hidden;*/
    padding-left: 72px;
    background: #F0F0F3;
    display: flex;
    width: 100%;
    transition: padding-left 0.4s;
}

.main.open {
    padding-left: 325px;
}

.main.setting_main:after {
    display: none;
}

.main.empty__trash {
    position: relative;
}

.main.empty__trash:after {
    display: none;
}

.main:after {
    content: "";
    width: 8px;
    height: calc(100vh - 110px);
    position: absolute;
    right: 338px;
    top: 100px;
    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 4px #FFFFFFB2;
    border-radius: 67px;
}

.main .content {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 56px 24px 24px 24px;
    height: 100%;
    width: calc(100% - 338px);
    margin-left: 24px;
    margin-top: -24px;
    position: relative;
}

.main .content::-webkit-scrollbar-track {
    box-shadow: unset;
}

.main .content::-webkit-scrollbar-track-piece:end {
    background: transparent;
}

.main .content::-webkit-scrollbar-track-piece:start {
    background: transparent;
}

.main .content.list {
    padding-left: 120px;
}

.to__top {
    position: absolute;
    right: 24px;
    margin-left: auto;
    bottom: 24px;
    z-index: 3;
    width: 40px;
    height: 40px;
    background: #F0F0F3;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s;
}

.to__top__icon {
    width: 26px;
    height: 26px;
}

.layout__block {
    position: absolute;
    right: 24px;
    top: 56px;
    display: flex;
    flex-direction: column;
}

.layout__list,
.layout__grid {
    margin-left: auto;
    width: 40px;
    height: 40px;
    background: #F0F0F3;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s;
    margin-bottom: 24px;
    cursor: pointer;
}

.empty__trash__title {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: max-content;
    height: max-content;
    font-size: 100px;
    font-weight: normal;
    font-style: normal;
    letter-spacing: 0;
    color: transparent;
    background: rgba(102, 102, 102, 0.2);
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    text-shadow: 0px 3px 3px rgba(255, 255, 255, 0.5);
}

.aside {
    width: 338px;
    padding: 24px;
    overflow-y: auto;
    height: 100%;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
}

.add__wallet__btn {
    box-shadow: -4px -4px 12px #FFFFFF, 4px 4px 12px #AEAEC067;
    background-color: #f0f0f3;
    border-radius: 24px;
    width: 288px;
    height: 88px;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding-left: 24px;
    padding-right: 30px;
    justify-content: space-between;
    font-size: 24px;
    color: #364048;
    text-transform: capitalize;
    font-weight: 600;
    transition: all 0.4s;
}

.add__wallet__btn:hover {
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;
}

.add__wallet__btn.defi {
    padding: 0 16px;
}

.add__wallet__btn.defi .add__wallet__btn__plus {
    width: 88px;
    height: 56px;
    border-radius: 157px;
    padding: 0 8px;
    margin-right: 12px;
}

.add__wallet__btn__plus {
    background: #F0F0F3;
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.add__wallet__btn__plus.defi {
    width: auto;
}

.add__wallet__btn__plus .fox {
    width: 32px;
    height: 25px;
    margin-right: 8px;
}

.add__wallet__btn__plus .coinbase {
    width: 25px;
    height: 25px;
}

.add__wallet__btn__plus__bg {
    background: #1762A2;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 2px 2px 2px rgba(255, 255, 255, 0.44), 10px 10px 30px rgba(174, 174, 192, 0.44), inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;
    position: relative;
}

.add__wallet__btn__plus__bg span {
    width: 12px;
    height: 2px;
    background: #F0F0F3;
    border-radius: 2px;
    position: absolute;
}

.add__wallet__btn__plus__bg span:nth-child(2) {
    transform: rotate(90deg);
}

.aside__wallet__title {
    color: #364048;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    margin-top: 39px;
    margin-bottom: 25px;
    text-align: center;
}

.aside__chart__wrapper {
    position: relative;
    margin-bottom: 45px;
    height: 315px;
}

.aside__chart__wrapper.cold .card__risk__chart__min {
    border-color: #4DC7B5;
}

.aside__chart__wrapper.cold .card__risk__chart__number__of,
.aside__chart__wrapper.cold .card__risk__chart__number {
    color: #4DC7B5;
}

.aside__chart__wrapper.cold .card__risk__info:hover {
    background: #4DC7B5;
    color: #ffffff;
}

.aside__chart__wrapper.hold .card__risk__chart__min {
    border-color: #EFB661;
}

.aside__chart__wrapper.hold .card__risk__chart__number__of,
.aside__chart__wrapper.hold .card__risk__chart__number {
    color: #EFB661;
}

.aside__chart__wrapper.hold .card__risk__info:hover {
    background: #EFB661;
    color: #ffffff;
}

.aside__chart__wrapper.risky .card__risk__chart__min {
    border-color: #F27281;
}

.aside__chart__wrapper.risky .card__risk__chart__number__of,
.aside__chart__wrapper.risky .card__risk__chart__number {
    color: #F27281;
}

.aside__chart__wrapper.risky .card__risk__info:hover {
    background: #F27281;
    color: #ffffff;
}

.aside__chart__wrapper .card__risk__chart {
    width: 232px;
    height: 232px;
    border-radius: 50%;
    margin: 0 auto;
}

.aside__chart__wrapper .card__risk__chart__min {
    width: 178px;
    height: 178px;
    border-width: 20px;
}

.aside__chart__wrapper .card__risk__chart__number {
    font-size: 35px;
}

.aside__chart__wrapper .card__risk__chart__number__of {
    font-size: 19px;
}

.aside__chart__wrapper .card__risk__alert {
    width: 90px;
    height: 90px;
    top: unset;
    bottom: 6px;
    right: -8px;
}

.aside__chart__wrapper .card__risk__alert__title {
    font-size: 20px;
    line-height: 26px;
}

.aside__chart__wrapper .card__risk__alert__number {
    font-size: 20px;
    line-height: 26px;
}

.aside__chart__wrapper .card__risk__range__hr {
    top: unset;
    bottom: 47px;
    left: 0;
}

.aside__tabs {
    display: flex;
    list-style-type: none;
    justify-content: space-between;
    position: relative;
    margin-bottom: 34px;
}

.aside__tabs:after {
    content: "";
    width: calc(100% + 24px);
    left: -12px;
    bottom: -10px;
    height: 3px;
    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 0px #FFFFFFB2;
    position: absolute;
    background: #F0F0F3;
}

.aside__tabs__link {
    text-decoration: none;
    color: #9CA3A8;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    position: relative;
    display: flex;
}

.aside__tabs__link:after {
    content: "";
    width: 0;
    transition: all 0.4s;
    height: 3px;
    background: #2658AA;
    box-shadow: inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF;
    border-radius: 67px;
    position: absolute;
    bottom: -10px;
    z-index: 1;
}

.aside__tabs__link:hover, .aside__tabs__link.active {
    color: #364048;
}

.aside__tabs__link:hover:after, .aside__tabs__link.active:after {
    width: 100%;
}

.aside__card {
    background: #F0F0F3;
    box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;
    border-radius: 24px;
    padding: 21px 24px 15px;
    position: relative;
    margin-bottom: 24px;
}

.aside__card.cold .aside__card__progress__bg {
    background: #28B663;
}

.aside__card.hot .aside__card__progress__bg {
    background: #EFB661;
}

.aside__card__title {
    color: #9CA3A8;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 8px;
}

.aside__card__numbers {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    display: flex;
    align-items: flex-end;
    margin-bottom: 15px;
}

.aside__card__numbers span {
    font-size: 14px;
    display: flex;
    margin-bottom: -10px;
}

.aside__card__progress {
    width: 100%;
    height: 8px;
    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 0px #FFFFFFB2;
    border-radius: 67px;
    background: #F0F0F3;
}

.aside__card__progress__bg {
    height: 100%;
    box-shadow: inset -2px -2px 2px #1D1D1D41, -10px -10px 30px #FFFFFF, inset 4px 4px 4px #AEAEC033;
    border-radius: 67px;
    transition: all 0.4s;
}

.aside__card .card__risk__alert {
    position: relative;
    margin-left: auto;
    font-weight: 600;
    width: 64px;
    height: 64px;
    top: 4px;
    right: -11px;
}

.aside__card .card__risk__alert__number,
.aside__card .card__risk__alert__title {
    line-height: 16px;
    font-size: 16px;
}

.aside__card .card__risk__range__hr {
    width: 105px;
    top: 60px;
    left: 80px;
}

.wallet__type__wrapper {
    position: relative;
    width: 168px;
    height: 44px;
}

.wallet__type {
    position: absolute;
    top: 0;
    left: 0;
    width: 168px;
    padding: 9px 0;
    border-radius: 24px;
    box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);
    background-color: #ededef;
    cursor: pointer;
}

.wallet__type.open .wallet__type__item:nth-of-type(n + 2) {
    display: flex;
}

.wallet__type.open .wallet__type__arrow {
    transform: rotate(180deg);
}

.wallet__type__item {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: normal;
    text-align: center;
    width: 100%;
    margin-top: 12px;
    display: flex;
    align-items: center;
    padding-left: 18px;
    color: #364048;
    white-space: nowrap;
}

.wallet__type__item:nth-of-type(1) {
    margin-top: 0;
}

.wallet__type__item.selected_btc {
    width: min-content;
    margin: 0 auto;
    padding-right: 15px;
}

.wallet__type__item:nth-of-type(n + 2) {
    display: none;
}

.wallet__type .wallet__type__arrow {
    position: absolute;
    right: 17px;
    top: 17px;
    filter: brightness(0) saturate(100%) invert(24%) sepia(8%) saturate(958%) hue-rotate(165deg) brightness(93%) contrast(94%);
    height: 8px;
}

.wallet__type__btn {
    width: 168px;
    height: 48px;
    border-radius: 80px;
    background: #F0F0F3;
    margin-left: 16px;
    color: #364048;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 18px;
    box-shadow: inset -5px -5px 5px #FFFFFFB2, inset 5px 5px 5px #AEAEC033;
}

.wallet__type__save {
    width: 104px;
    height: 40px;
    border-radius: 67px;
    box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);
    background-color: #214175;
    font-size: 18px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-left: auto;
    cursor: pointer;
    border: 0;
}

.wallet__addresses {
    border-radius: 22px;
    background-color: #ededef;
    padding: 24px;
    margin-top: 24px;
}

.wallet__addresses__top {
    display: flex;
    position: relative;
}

.wallet__addresses__top .card__close {
    position: absolute;
    right: 0;
}

.wallet__addresses__top__left {
    margin-right: 16px;
}

.wallet__addresses__top__left .wallet__addresses__top__label {
    text-align: center;
}

.wallet__addresses__top__label {
    margin-bottom: 4px;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.36;
    text-align: left;
    color: #364048;
}

.wallet__addresses__top__middle {
    margin-right: 16px;
}

.wallet__addresses__top__middle .wallet__addresses__top__label {
    margin-left: 25px;
}

.wallet__addresses__top__input__wrapper {
    width: 584px;
    height: 48px;
    border-radius: 80px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    background: #EDEDEF;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    padding: 8px;
}

.wallet__addresses__top__input {
    width: calc(100% - 32px);
    height: 100%;
    background-color: transparent;
    border: 0;
    text-align: center;
    outline: none;
    font-size: 18px;
    font-weight: 600;
    color: #364048;
}

.wallet__addresses__top__input__add {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: #EDEDEF;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;
    border-radius: 24px;
    width: 32px;
    height: 32px;
    border: 0;
    outline: none;
    cursor: pointer;
}

.wallet__addresses__top__input__add span {
    width: 12px;
    height: 2px;
    background: #2167A4;
    border-radius: 2px;
    position: absolute;
}

.wallet__addresses__top__input__add span:nth-child(2) {
    transform: rotate(90deg);
}

.wallet__addresses__top__right__btn {
    width: 112px;
    height: 48px;
    margin-top: 28px;
    padding: 9px 0;
    position: relative;
    border-radius: 24px;
    box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);
    background-color: #ededef;
    font-size: 18px;
    color: #364048;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    cursor: pointer;
    outline: none;
    top: 7px;
    font-weight: 500;
}

.limit__block {
    width: 168px;
    height: 96px;
    background: #EDEDEF;
    border-radius: 21px;
}

.limit__block__bottom, .limit__block__top {
    height: 50%;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.limit__block__top {
    color: #364048;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 21px 21px 0 0;
    position: relative;
}

.limit__block__top.active .limit__block__top__slider {
    opacity: 1;
    visibility: visible;
}

.limit__block__bottom {
    color: #4DC7B5;
    font-weight: 600;
    background-color: #f0f0f3;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 0 0 21px 21px;
}

.limit__block__wrapper {
    display: flex;
    padding: 16px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 0 21px 21px 21px;
}

.wallet__addresses__bottom {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
}

.wallet__addresses__bottom .limit__block {
    margin-right: 16px;
}

.wallet__addresses__bottom .limit__block:last-child {
    margin-right: 0;
}

.wallet__addresses__bottom__right,
.wallet__addresses__bottom__left {
    padding-bottom: 15px;
}

.wallet__addresses__bottom__middle {
    margin-left: 16px;
    margin-right: 32px;
}

.limit__block__tabs {
    list-style-type: none;
    display: flex;
}

.limit__block__tabs__list {
    padding: 14px 16px 8px;
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    color: #364048;
    background: #EDEDEF;
    box-shadow: -2px 0px 6px #AEAEC02F;
    border-radius: 24px 24px 0 0;
    cursor: pointer;
    transition: all 0.4s;
}

.limit__block__tabs__list:hover, .limit__block__tabs__list.active {
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
}

.anomalies__label {
    width: 112px;
    height: 112px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;
}

.anomalies__check {
    display: none;
}

.anomalies__check:checked ~ .anomalies__label {
    background: transparent linear-gradient(51deg, #EDEDEF 0%, #DEE5F0 100%) 0% 0% no-repeat padding-box;
    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 2px #FFFFFFB2;
}

.anomalies__check:checked ~ .anomalies__label .anomalies__check__box:after {
    opacity: 1;
    visibility: visible;
}

.anomalies__text {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #364048;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    margin-bottom: 6px;
}

.anomalies__check__box {
    width: 24px;
    display: flex;
    height: 24px;
    box-shadow: inset 2px 2px 2px #AEAEC033, inset -2px -2px 2px #FFFFFFB2;
    border-radius: 6px;
    position: relative;
}

.anomalies__check__box:after {
    content: "";
    width: 6px;
    position: absolute;
    left: 8px;
    top: 2px;
    height: 12px;
    border-bottom: 2px solid #364048;
    border-right: 2px solid #364048;
    transform: rotate(45deg) skew(10deg);
    opacity: 0;
    visibility: hidden;
}

.limit__block__top__slider {
    background: #EDEDEF;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;
    width: 184px;
    height: 184px;
    border-radius: 50%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -32px;
    opacity: 0;
    transition: all 0.4s;
    visibility: hidden;
}

.limit__block__top__slider__info {
    width: 152px;
    height: 152px;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-radius: 50%;
    border: 20px solid #214175;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.limit__block__top__slider__info__time {
    color: #214175;
    font-weight: bold;
    font-size: 26px;
    line-height: 34px;
}

.limit__block__top__slider__info__time__of {
    color: #214175;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
}

.whitelist__ad__block__wrapper {
    position: absolute;
    top: 80px;
    right: -30px;
    /*overflow: hidden;*/
    transition: right 0.4s;
}

.whitelist__ad__block__wrapper.open {
    overflow: unset;
    right: 0;
}

.whitelist__ad__block {
    position: absolute;
    background: #F0F0F3;
    box-shadow: 0 5px 15px #38465240;
    border-radius: 20px;
    width: 920px;
    padding: 32px 32px 45px;
    right: -100%;
    top: 0;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.6s, visibility 0.8s, right 0.8s;
}

.whitelist__ad__block.open {
    right: 0;
    opacity: 1;
    visibility: visible;
}

.whitelist__ad__block .row {
    justify-content: space-between;
}

.whitelist__ad__block__bottom {
    width: 100%;
    position: relative;
    margin-top: 8px;
}

.whitelist__ad__block__bottom .add__wallet__btn__plus__bg {
    margin: 0 auto;
    cursor: pointer;
    display: flex;
}

.whitelist__ad__block__bottom .dropdown {
    position: absolute;
    right: 0;
    top: 0;
}

.whitelist__ad__block__input__wrapper {
    width: 416px;
    height: 48px;
    border-radius: 80px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    background: #EDEDEF;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    padding: 8px;
}

.whitelist__ad__block__input {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 0;
    text-align: center;
    outline: none;
    font-size: 18px;
    font-weight: 600;
    color: #364048;
}

.add__wallet__addresses {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 20px;
}

.card.defi {
    padding-top: 8px;
    position: relative;
}

.card.defi .card__header .row {
    align-items: center;
}

.card.defi .card__wallet__row {
    background-color: transparent;
}

.card.defi .card__wallet__rates {
    color: #889096;
}

.card.defi .card__wallet__usd {
    color: #364048;
    font-weight: bold;
}

.card.defi .card__product__row {
    padding-bottom: 0;
}

.card.defi .card__title {
    font-weight: 600;
    display: inline-flex;
    align-items: center;
}

.card.defi .card__header {
    padding: 10px 0;
}

.card.defi .card__header .row {
    align-items: center;
    justify-content: center;
}

.card.defi .card__header .card__close {
    position: absolute;
    top: 22px;
    right: 15px;
}

.card.defi .card__price {
    margin-bottom: 5px;
}

.card.defi .card__risk__title {
    margin-bottom: 10px;
}

.card__product__stake__amount {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    right: -100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 408px;
    background: #F0F0F3;
    box-shadow: 10px 10px 30px #6F6F8467;
    border-radius: 12px;
    z-index: 2;
    padding: 24px 16px 16px 24px;
}

.card__product__stake__amount.open {
    visibility: visible;
    opacity: 1;
}

.card__product__stake__amount__input__wrapper {
    width: 224px;
    height: 48px;
    border-radius: 80px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    background: #EDEDEF;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    padding: 8px;
}

.card__product__stake__amount__input {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 0;
    text-align: center;
    outline: none;
    font-size: 18px;
    font-weight: 600;
    color: #364048;
}

.card__product__stake__amount__max {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    width: 128px;
    height: 48px;
    color: #364048;
    border-radius: 24px;
    box-shadow: -3px -3px 9px 0 #fff, 3px 3px 9px 0 rgba(174, 174, 192, 0.4);
    background-color: #ededef;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    cursor: pointer;
    outline: none;
}

.card__product__stake__amount__confirm {
    width: 100%;
    height: 40px;
    border-radius: 67px;
    box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgba(174, 174, 192, 0.4);
    background-color: #214175;
    font-size: 18px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    border: 0;
    margin-top: 8px;
}

.unstacking {
    width: 95px;
    height: 95px;
    border-radius: 50%;
    background: #F0F0F3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -3px -3px 9px #FFFFFF, 3px 3px 9px #AEAEC067;
    color: #889096;
    font-size: 16px;
    line-height: 18px;
    flex-direction: column;
    text-align: center;
    position: absolute;
    right: -13px;
    bottom: -18px;
    transition: all 0.4s;
}

.unstacking span {
    color: #F27281;
}

.unstacking.active, .unstacking:hover {
    box-shadow: unset;
    color: rgba(136, 144, 150, 0.49);
    cursor: pointer;
}

.unstacking.active span, .unstacking:hover span {
    color: rgba(136, 144, 150, 0.49);
}

.add__defi__block {
    width: 56px;
    padding: 16px 0;
    background: #F0F0F3;
    box-shadow: inset 4px 4px 4px #AEAEC033, inset -4px -4px 4px #FFFFFFB2;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: absolute;
    right: 16px;
    top: 45px;
}

.add__defi__item {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F0F0F3;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;
    border-radius: 8px;
    margin-bottom: 16px;
    cursor: pointer;
}

.add__defi__item:nth-child(1) {
    height: auto;
    margin-bottom: 8px;
    box-shadow: unset;
    background-color: transparent;
}

.add__defi__item:last-child {
    margin-bottom: 0;
}

.card.light {
    padding-top: 25px;
    position: relative;
}

.card.light .card__header {
    margin-bottom: 30px;
    position: relative;
}

.card.light .card__header .row {
    align-items: center;
    justify-content: center;
}

.card.light .card__header .card__close {
    position: absolute;
    top: 5px;
    right: 0;
}

.card.light .card__wallet__row {
    background-color: transparent;
}

.card.light .card__wallet__rates {
    color: #889096;
}

.card.light .card__wallet__usd {
    color: #364048;
    font-weight: bold;
}

.card.light .card__title {
    font-weight: 600;
    display: inline-flex;
    align-items: center;
}

.card.light .card__product__arrow {
    margin-left: 10px;
}

.card.light .card__product__wrapper {
    margin-bottom: 14px;
}

.setting {
    height: 100%;
    width: 100%;
    overflow-y: auto;
}

.setting > .row {
    width: 100%;
    align-items: stretch;
    height: 100%;
}

.user__info__wrapper {
    padding: 56px 50px 56px 100px;
    height: 100%;
}

.user__info {
    width: 368px;
    position: relative;
    margin-bottom: 24px;
    padding-top: 56px;
}

.user__info__avatar__block {
    width: 100%;
    height: 368px;
    background: #F0F0F3 linear-gradient(132deg, #ECECF0 0%, #F2F2F5 100%) 0 0;
    border-radius: 50%;
    box-shadow: -8px -8px 15px #FFFFFF, 8px 8px 15px #AEAEC067;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.user__info__avatar__wrapper {
    width: 336px;
    height: 336px;
    border-radius: 50%;
    position: relative;
}

.user__info__avatar__wrapper:after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    box-shadow: -8px -8px 15px #FFFFFF, 8px 8px 15px #AEAEC067;
    z-index: 2;
    background: transparent radial-gradient(closest-side at 50% 50%, #69686F00 0%, #6A697180 94%, #727179 100%) 0% 0% no-repeat padding-box;
}

.user__info__desc__block {
    width: 100%;
    background: #F0F0F3;
    box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;
    border-radius: 30px;
    padding-top: 200px;
    margin-top: -200px;
    display: flex;
    flex-direction: column;
}

.user__info__name {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    color: #364048;
    text-align: center;
    box-shadow: inset 0 5px 5px #AEAEC033, inset 0px -5px 5px #FFFFFFB2;
    margin-top: 25px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.user__info__desc {
    box-shadow: inset 0 5px 5px #AEAEC033, inset 0px -5px 5px #FFFFFFB2;
    text-align: center;
    margin-top: 24px;
    padding: 24px 32px;
    margin-bottom: 99px;
}

.user__info__desc__text {
    font-size: 22px;
    line-height: 28px;
    color: #364048;
}

.login__settings {
    background: #F0F0F3;
    box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px #AEAEC067;
    border-radius: 30px;
    min-width: 544px;
    margin-right: 72px;
    margin-bottom: 24px;
}

.login__settings__title {
    padding: 32px 0;
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    color: #364048;
    text-align: center;
}

.password__change__block {
    padding: 20px 0 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 5px 5px #AEAEC033, inset 0px -5px 5px #FFFFFFB2;
}

.password__change__block__title {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #364048;
    text-align: center;
    margin-bottom: 21px;
}

.password__change__input {
    width: 304px;
    height: 48px;
    background: #F0F0F3;
    border: 0;
    border-radius: 67px;
    text-align: center;
    font-size: 18px;
    line-height: 23px;
    font-weight: 600;
    outline: none;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    margin-bottom: 16px;
    display: inline-flex;
}

.password__change__input::placeholder {
    color: #939A9F;
}

.password__change__btn {
    width: 304px;
    height: 40px;
    box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;
    background: #214175;
    color: #FFFFFF;
    font-weight: 600;
    font-size: 18px;
    line-height: 23;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 67px;
    cursor: pointer;
    outline: none;
    border: 0;
}

.qr__wrapper {
    width: 112px;
    height: 112px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    border-radius: 16px;
    padding: 8px;
    margin-top: 16px;
}

.qr__img {
    width: 96px;
    height: 96px;
    /*overflow: hidden;*/
    border-right: 16px;
}

.alerts__input__box {
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.alerts__input__wrapper {
    width: 100%;
    transition: all 0.4s;
    height: 48px;
    background: #F0F0F3;
    border-radius: 67px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}

.alerts__input__wrapper.disable {
    width: 304px;
}

.alerts__input__wrapper.disable .alerts__input__add {
    display: none;
}

.alerts__input__wrapper.disable .alerts__input {
    color: #939A9F;
}

.alerts__input__wrapper.disable .alerts__input__check {
    display: flex;
}

.alerts__input__wrapper.active {
    width: 304px;
}

.alerts__input__wrapper.active .alerts__input__add {
    display: none;
}

.alerts__input__wrapper.active .alerts__input {
    color: #364048;
}

.alerts__input__wrapper.active.one {
    width: 100%;
}

.alerts__input__wrapper.active.one .alerts__input__add {
    display: flex;
}

.alerts__input__wrapper.links .alerts__input__icon__wrapper {
    width: auto;
    box-shadow: unset;
}

.alerts__input__wrapper.links .alerts__input__icon {
    cursor: pointer;
    margin-right: 10px;
}

.alerts__input__wrapper.links .alerts__input__icon:last-child {
    margin-right: 0;
}

.alerts__input__wrapper.links .alerts__input {
    display: none;
}

.alerts__input__wrapper.links .alerts__input__check {
    display: none;
}

.alerts__input__wrapper .alerts__input {
    width: 205px;
    background-color: transparent;
    border: 0;
    outline: none;
    text-align: center;
    font-size: 18px;
    line-height: 23px;
    transition: all 0.4s;
}

.alerts__input__wrapper .alerts__input::placeholder {
    color: #939A9F;
}

.alerts__input__wrapper .alerts__input__check {
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;
    box-shadow: inset 2px 2px 2px #AEAEC033, inset -2px -2px 2px #FFFFFFB2;
    border-radius: 6px;
    margin-right: 15px;
    margin-left: 10px;
    transition: all 0.4s;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.alerts__input__wrapper .alerts__input__check .alerts__input__check__icon {
    opacity: 0;
    visibility: hidden;
    transition: all 0.4s;
}

.alerts__input__wrapper .alerts__check__input {
    display: none;
}

.alerts__input__wrapper .alerts__check__input:checked ~ .alerts__input__check .alerts__input__check__icon {
    visibility: visible;
    opacity: 1;
}

.alerts__input__icon__wrapper {
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    display: flex;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    align-items: center;
    justify-content: center;
}

.alerts__input__add {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    box-shadow: -2px -2px 6px #FFFFFF, 2px 2px 6px #AEAEC067;
    background: #EDEDEF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 10px;
    cursor: pointer;
}

.login__settings__wrapper {
    width: calc(100% - 518px);
    display: flex;
    overflow-x: auto;
    overflow-y: auto;
    padding-top: 56px;
    padding-left: 32px;
}

.login__settings__wrapper::-webkit-scrollbar-track {
    box-shadow: unset;
}

.login__settings__wrapper::-webkit-scrollbar-track-piece:end {
    background: transparent;
}

.login__settings__wrapper::-webkit-scrollbar-track-piece:start {
    background: transparent;
}

.password__change__label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.password__change__label.hasValue .password__change__label__text {
    visibility: visible;
    opacity: 1;
    position: relative;
}

.password__change__label__text {
    display: inline-flex;
    width: 95px;
    height: 16px;
    justify-content: center;
    align-items: center;
    border-radius: 8px 8px 0 0;
    box-shadow: inset 5px 5px 5px #aeaec033, inset -5px -5px 5px #ffffffb2;
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transition: all 0.4s;
}

.nft .card__title {
    height: 48px;
}

.login__wrapper {
    width: 100%;
    min-height: 100vh;
    max-height: 1080px;
    /*overflow: hidden;*/
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: relative;
}

.login__big {
    width: 1790px;
    height: 1782px;
    position: absolute;
    object-fit: contain;
    object-position: 44px;
    padding-left: 44px;
    z-index: 4;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    animation: rotation_big 30s infinite linear;
}

.login__middle {
    width: 1100px;
    height: 1100px;
    position: absolute;
    object-fit: contain;
    z-index: 3;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    animation: rotation__middle 30s infinite linear reverse;
}

.login__small {
    width: 828px;
    height: 828px;
    position: absolute;
    object-fit: contain;
    z-index: 2;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    animation: rotation__small 30s infinite linear;
}

.login__round {
    width: 1208px;
    height: 1208px;
    position: absolute;
    object-fit: contain;
    object-position: center 55px;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}

.login__form {
    width: 554px;
    height: 554px;
    background: #F0F0F3;
    box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px #AEAEC067;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.login__logo {
    width: 200px;
    height: 36px;
    margin-bottom: 38px;
    display: inline-flex;
}

.login__input__wrapper {
    width: 304px;
    height: 48px;
    background: #F0F0F3;
    border-radius: 67px;
    box-shadow: inset 5px 5px 5px #AEAEC033, inset -5px -5px 5px #FFFFFFB2;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.login__input__wrapper .login__input {
    width: 100%;
    background-color: transparent;
    border: 0;
    outline: none;
    text-align: center;
    font-size: 18px;
    line-height: 23px;
    transition: all 0.4s;
}

.login__input__wrapper .login__input::placeholder {
    color: #939A9F;
}

.login__btn {
    width: 304px;
    height: 40px;
    box-shadow: -5px -5px 15px #FFFFFF, 5px 5px 15px #AEAEC067;
    background: #214175;
    color: #FFFFFF;
    font-weight: 600;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 67px;
    cursor: pointer;
    outline: none;
    border: 0;
}

.login__user__btn {
    position: fixed;
    cursor: pointer;
    width: 128px;
    height: 128px;
    bottom: 24px;
    right: 16px;
    z-index: 99;
}

.purchase__form {
    background: #F0F0F3;
    width: 408px;
    height: 492px;
    border-radius: 67px;
    box-shadow: -10px -10px 30px #FFFFFF, 10px 10px 30px #AEAEC067;
    padding: 40px 48px 33px;
    position: fixed;
    bottom: 24px;
    right: 16px;
    z-index: 100;
    visibility: hidden;
    opacity: 0;
    transition: all 0.4s;
}

.purchase__form.open {
    visibility: visible;
    opacity: 1;
}

.purchase__form__title {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 32px;
}

@media only screen and (max-width: 1700px) {
    .nav {
        width: 71px;
    }

    .header {
        height: 56px;
        min-height: 56px;
        padding-left: 90px;
    }

    .nav__link {
        width: 40px;
        height: 40px;
        font-size: 22px;
    }

    .nav__link:hover, .nav__link.active {
        border-radius: 8px;
    }

    .card {
        max-width: 240px;
        height: 352px;
        margin-right: 30px;
        margin-bottom: 30px;
    }

    .card__product__title {
        font-size: 14px;
    }

    .card__risk {
        margin-top: 12px;
    }

    .card__risk__chart {
        width: 112px;
        height: 112px;
    }

    .card.empty .card__risk__chart__min,
    .card__risk__chart__min {
        width: 90px;
        height: 90px;
    }

    .card__risk__chart__number {
        font-size: 20px;
        line-height: 26px;
    }

    .card__wallet__usd, .card__wallet__rates {
        font-size: 14px;
    }

    .unstacking {
        width: 80px;
        height: 80px;
        font-size: 14px;
    }

    .card {
        padding: 16px;
        border-radius: 24px;
    }

    .card__price {
        height: 32px;
        border-radius: 80px;
        font-size: 14px;
    }

    .card__title {
        font-size: 14px;
    }

    .card.light {
        padding-top: 20px;
    }

    .card.light .card__header {
        margin-bottom: 12px;
    }

    .card__close {
        width: 12px;
        height: 12px;
    }

    .card__close span {
        width: 1px;
    }

    .card.light .card__header .card__close {
        top: 1px;
    }

    .card__product__row {
        margin: 0;
        padding: 0;
    }

    .card__product__number {
        font-size: 18px;
        line-height: 23px;
    }

    .card__risk__range {
        width: 6px;
        height: 133px;
    }

    .card__risk__range__btn {
        width: 18px;
        height: 18px;
        left: -6px;
    }

    .card__risk__info {
        bottom: -15px;
    }

    .card__wallet__row {
        padding: 0 10px;
    }

    .layout__list, .layout__grid {
        width: 32px;
        height: 32px;
        margin-bottom: 16px;
    }

    .layout__block {
        right: 15px;
        top: 16px;
    }

    .layout__grid__icon {
        width: 18px;
        height: 18px;
    }

    .layout__list__icon {
        width: 19px;
        height: 19px;
    }

    .card__risk__title {
        font-size: 14px;
        line-height: 15px;
        margin-bottom: 10px;
    }

    .card__risk__range__btn__min {
        width: 12px;
        height: 12px;
    }

    .card__risk__alert {
        width: 48px;
        height: 48px;
    }

    .card__risk__alert__title {
        font-size: 13px;
    }

    .aside__wallet__title {
        font-size: 16px;
        line-height: 21px;
        margin-bottom: 20px;
        margin-top: 25px;
    }

    .main .content {
        margin-left: 0;
        width: calc(100% - 234px);
        padding: 16px 24px 0 17px;
        margin-top: 0;
    }

    .main:after {
        right: 234px;
        width: 5px;
        top: 72px;
    }

    .aside {
        width: 234px;
        padding: 16px;
    }

    .add__wallet__btn {
        width: 200px;
        height: 64px;
        border-radius: 18px;
        font-size: 16px;
        line-height: 21px;
        padding-left: 16px;
    }

    .add__wallet__btn__plus {
        width: 40px;
        height: 40px;
    }

    .add__wallet__btn__plus__bg {
        width: 25px;
        height: 25px;
    }

    .setting {
        margin-left: 30px;
    }

    .login__settings.login__settings_notification,
    .login__settings {
        width: calc(100% / 3 - 20px);
        margin-left: 40px;
    }

    .card__risk__range__hr {
        width: 121px;
        height: 5px;
    }

    .card__risk__range__btn__hr {
        width: 17px;
        height: 17px;
    }

    .card__risk__range__btn__hr__min {
        width: 11px;
        height: 11px;
    }

    .aside__tabs__link {
        font-size: 14px;
    }

    .aside__chart__wrapper {
        height: 235px;
        margin-bottom: 30px;
    }

    .aside__chart__wrapper .card__risk__chart {
        width: 158px;
        height: 158px;
    }

    .aside__chart__wrapper .card__risk__chart__min {
        width: 122px;
        height: 122px;
        border-width: 14px;
    }

    .aside__chart__wrapper .card__risk__alert {
        width: 64px;
        height: 64px;
    }

    .aside__chart__wrapper .card__risk__alert__title,
    .aside__chart__wrapper .card__risk__alert__number {
        font-size: 14px;
        line-height: 18px;
    }

    .aside__card__title {
        font-size: 14px;
        margin-bottom: 3px;
        line-height: 17px;
    }

    .aside__card__numbers {
        font-size: 16px;
    }

    .aside__card {
        padding: 14px 16px;
        border-radius: 18px;
    }

    .aside__card .card__risk__alert {
        width: 44px;
        height: 44px;
        top: 0;
    }

    .aside__card .card__risk__alert__number,
    .aside__card .card__risk__alert__title {
        font-size: 13px;
    }

    .aside__card .card__risk__range__hr {
        width: 71px;
        height: 6px;
    }

    .aside__card__progress {
        height: 6px;
    }

    .card__wallet {
        margin-bottom: 10px;
        height: 70px;
    }

    .to__top {
        width: 32px;
        height: 32px;
        right: 15px;
    }

    .to__top__icon {
        width: 20px;
        height: 20px;
    }

    .card__product__unstacked,
    .card__product__stake {
        width: 88px;
        height: 32px;
        font-size: 14px;
    }

    .card.defi .card__header {
        padding: 0;
    }

    .card.defi .card__risk {
        margin-top: 5px;
    }

    .card__product__stake__block {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .card__product__stake__amount__max,
    .card__product__stake__amount__input {
        font-size: 14px;
    }

    .card__product__stake__amount__max,
    .card__product__stake__amount__input__wrapper {
        height: 40px;
    }

    .card__product__stake__amount__confirm {
        font-size: 14px;
        height: 35px;
    }

    .card__product__stake__amount {
        right: -145%;
    }

    .add__defi__block {
        width: 42px;
        padding: 8px 0;
        top: 16px;
    }

    .add__defi__item {
        width: 28px;
        height: 28px;
        margin-bottom: 8px;
    }

    .add__defi__item__icon {
        height: 20px;
        width: auto;
    }

    .card__nft__wrapper {
        width: 192px;
        height: 124px;
        margin: 0 auto;
    }

    .card__nft__img {
        width: 176px;
        height: 110px;
    }

    .card.nft .card__header {
        margin-bottom: 0;
    }

    .card.nft .card__risk {
        margin-top: 4px;
    }

    .login__big {
        width: calc(1790 / 1.3 * 1px);
        height: calc(1782 / 1.3 * 1px);
    }

    .login__middle {
        width: calc(1100 / 1.3 * 1px);
        height: calc(1100 / 1.3 * 1px);
    }

    .login__small {
        width: calc(828 / 1.3 * 1px);
        height: calc(828 / 1.3 * 1px);
    }

    .login__round {
        width: calc(1208 / 1.3 * 1px);
        height: calc(1208 / 1.3 * 1px);
    }

    .login__form {
        width: calc(544 / 1.3 * 1px);
        height: calc(544 / 1.3 * 1px);
    }

    .login__input__wrapper {
        width: 285px;
        height: 40px;
    }

    .login__btn {
        width: 285px;
    }

    .login__logo {
        margin-bottom: 20px;
    }

    .card.new .add__wallet,
    .card.empty .add__wallet {
        width: 112px;
        height: 112px;
    }

    .card.new .add__wallet .add__wallet__btn__bg,
    .card.empty .add__wallet .add__wallet__btn__bg {
        width: 60px;
        height: 60px;
    }

    .card.new .add__wallet .save__text,
    .card.empty .add__wallet .save__text {
        font-size: 16px;
    }

    .card.new .add__wallet .plus__wrapper span,
    .card.empty .add__wallet .plus__wrapper span {
        width: 20px;
        height: 3px;
    }

    .card.new .add__wallet.save,
    .card.empty .add__wallet.save {
        top: 188px;
    }

    .card__product__row .product__row__dropdown .product__row__dropdown__item {
        font-size: 14px;
        padding: 3px 0;
    }

    .card__product__row .product__row__dropdown {
        top: 24px;
        padding: 2px 12px;
    }

    .menu__open {
        width: 80px;
        height: 80px;
        right: -40px;
    }

    .menu__open__btn {
        width: 24px;
        height: 24px;
    }

    .menu__open__icon {
        width: 14px;
        height: 14px;
    }

    .card.trash .trash__wallet {
        width: 100px;
        height: 100px;
    }

    .trash__wallet__icon {
        width: 33px;
        height: 36px;
    }

    .empty__trash__title {
        font-size: 76px;
    }

    .card__list__anchor,
    .card__list__title {
        font-size: 14px;
    }

    .card__list {
        width: 256px;
        height: 64px;
        border-radius: 20px;
        padding: 8px;
        margin-right: 70px;
    }

    .card__risk__chart__list {
        width: 80px;
        height: 80px;
        right: -40px;
    }

    .card__list__percent {
        margin-right: 13px;
        width: 48px;
        height: 48px;
    }

    .card__risk__chart__list__number {
        font-size: 18px;
    }
    .light_defi_title_content .card__product__title{
        width: 168px !important;
    }
}

.light_defi_item{
    padding-bottom: 5px;
    border-bottom: 0.5px solid #949191;
}

/*# sourceMappingURL=style.css.map */

`, "",{"version":3,"sources":["webpack://./src/Assets/css/style.css","webpack://./src/Assets/css/base/_fonts.scss","webpack://./src/Assets/css/base/_core.scss","webpack://./src/Assets/css/base/_var.scss","webpack://./src/Assets/css/components/_form.scss","webpack://./src/Assets/css/components/_modal.scss","webpack://./src/Assets/css/components/_card.scss","webpack://./src/Assets/css/components/_chart.scss","webpack://./src/Assets/css/layout/_header.scss","webpack://./src/Assets/css/layout/_nav.scss","webpack://./src/Assets/css/layout/_main.scss","webpack://./src/Assets/css/layout/_aside.scss","webpack://./src/Assets/css/pages/_wallets_shield.scss","webpack://./src/Assets/css/pages/_defi_shield.scss","webpack://./src/Assets/css/pages/_light_defi.scss","webpack://./src/Assets/css/pages/_settings.scss","webpack://./src/Assets/css/pages/_light_nft.scss","webpack://./src/Assets/css/pages/_login.scss","webpack://./src/Assets/css/media/_media.scss","webpack://./src/Assets/css/media/_mx1440.scss"],"names":[],"mappings":"AAEA;ICAE,wBAAK;IACL,4CAAK;IAKL,4SAAmB;IACnB,mBAAkB;IAClB,kBAAkB;IAGpB,kBAWC;ADfD;;AAEA;ICUE,wBAAiB;IACjB,4CAAkB;IAClB,8SAAkB;IAGpB,iBAWC;IAVC,kBAAa;IACb,kBAAK;ADVP;;AAEA;ICgBE,wBAAkB;IAGpB,6CAWC;IAVC,iTAAwB;IACxB,iBAAK;IACL,kBAAK;IAKL,kBAAgB;ADpBlB;;ACyBA;IACE,wBAAwB;IACxB,6CAA+C;IAC/C,iTAIyE;IACzE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AAGpB;;AD3BA;IC8BE,wBAAK;IAKL,6CAAgB;IAChB,iTAAkB;IAClB,gBAAkB;IAGpB,kBAWC;IAVC,kBAAa;ADlCf;;AAEA;ICwCE,wBAAkB;IAClB,6CAAkB;ICxFlB,iTAAA;IACA,gBAAS;IACT,kBAAU;IACV,kBAAY;AFmDd;;AAEA;IACI,wBAAwB;IE9CvB,6CAAA;IACH,iTCP4B;IDQ5B,gBCXU;IDYV,kBCXc;IDYd,kBAAgB;AFgDlB;;AAEA;IE7CE,SAAU;IACV,UAAQ;IACR,sBAAkB;AF+CpB;;AE3CA;IACE,eAAa;AF8Cf;;AE1CA;IACE,oCAAW;IF6CT,gBAAgB;IEzCpB,cAAW;IACX,oBAAoB;AF2CpB;;AAEA;IExCA,WAAW;IACX,oBAAA;IACE,cAAY;IACZ,kBAAmB;IF0CjB,mBAAmB;AEtCvB;;AFyCA;IEtCE,aAAe;IFwCb,eAAe;AErCnB;;AFwCA;IACI,WAAW;AEpCf;;AFuCA,UEtCE;AFuCF;IACI,UAAU;IErCV,cAAY;AFuChB;;AAEA,UEpCE;AFqCF;IElCI,uCAAY;IFoCZ,mBAAmB;AEhCvB;;AFmCA,WEhCE;AFiCF;IACI,uBAAuB;IE7B3B,kBAAA;AF+BA;;AAEA,oBAAoB;AE5BpB;IACE,uBAAoB;AF8BtB;;AE3BA;;IF+BI,oBAAoB;AI5HxB;;AJ+HA;;IIzHM,sEAAsE;AJ4H5E;;AAEA;IItHM,oBAAc;AJwHpB;;AAEA;IInHE,wEAAW;AJqHb;;AAEA;IInHE,oBAAa;AJqHf;;AAEA;IInHE,mBAAe;AJqHjB;;AAEA;IACI,oBAAoB;IIlHxB,sEAAiB;AJoHjB;;AAEA;IACI,oBAAoB;IIjHxB,0DAAgB;AJmHhB;;AAEA;IIjHE,mBAAS;AJmHX;;AAEA;IIjHE,kBAAS;IACT,YAAa;AJmHf;;AAEA;IIhHE,sEAAmB;AJkHrB;;AAEA;IIhHE,0BAAuB;AJkHzB;;AAEA;IIhHE,cAAU;AJkHZ;;AI9GA;IACE,YAAW;IACX,WAAY;IACZ,mBAAY;IACZ,wDAAkB;IAClB,mBAAa;IACb,aAAa;IACb,mBAAiB;IACjB,uBAAkB;IAClB,gBAAU;IACV,eAAQ;IACR,kBAAe;IJiHb,UAAU;II9Gd,eAAe;AJgHf;;AAEA;II5GI,aAAA;IACE,WAAU;IAEV,kBAAA;AJ6GN;;AAEA;IACI,mBAAmB;IIpGvB,gCAAyB;IACvB,4BAAY;IACZ,uBAAW;IACX,kBAAmB;IACnB,WAAY;IACZ,UAAA;IACA,SAAS;IACT,aAAa;AJsGf;;AAEA;IIpGE,WAAU;IACV,mBAAU;IACV,YAAQ;IJsGN,aAAa;IIlGjB,mBAAqB;IACnB,uBAAkB;IAClB,cAAY;IACZ,gBAAe;IACf,eAAY;IACZ,kBAAW;IACX,sEAAS;AJoGX;;AAEA;IIhGA,WAAA;IACE,YAAc;IACd,wDAAgB;IAChB,kBAAe;IACf,aAAe;IACf,mBAAe;IAEf,uBAAA;IACE,kBAAgB;IAChB,UAAA;IAGF,QAAA;IACE,eAAc;AJ+FlB;;AAEA;IK/OE,gBAAM;IACN,kBAAO;IACP,YAAW;ALiPb;;AAEA;IK/OE,sEAAY;ALiPd;;AAEA;IACI,0BAA0B;AK9O9B;;ALiPA;IK9OE,cAAY;ALgPd;;AAEA;IK7OE,YAAS;IACP,WAAS;IACT,mBAAkB;IAClB,wDAAmB;IACnB,mBAAkB;IAClB,aAAa;IL+Ob,mBAAmB;IM1QvB,uBAAM;IACJ,gBAAgB;IAChB,eAAW;IACX,kBAAa;IACb,UAAY;IACZ,eAAY;AN4Qd;;AAEA;IM1QE,kBAAa;IACb,gCAAkB;IAClB,4BAAc;IACZ,mBAAU;IAGZ,WAAA;IACE,SAAQ;IACR,uBAAU;IACV,aAAY;AN0QhB;;AAEA;IACI,cMtQa;INuQb,gBMtQc;INuQd,eMtQa;INuQb,eMtQU;IAGV,gCAAA;ANqQJ;;AAEA;IMhQM,gBAAA;INkQF,mBMjQkB;ANkQtB;;AAEA;IACI,cM7PW;AN8Pf;;AAEA;IACI,eMzPW;IN0PX,MMxPI;INyPJ,OMxPM;IAQR,WAAA;IACE,aAAa;IAIb,aAAA;IACE,uBAAmB;IACnB,YAAY;IACZ,gBAAW;IACX,kBAAY;IACZ,kBAAM;AN+OZ;;AAEA;IM3OI,YAAA;IACE,mBAAmB;IACnB,+CAAY;IACZ,yBAAY;IACZ,oBAAa;IACb,mBAAkB;AN6OxB;;AAEA;IM3OM,aAAY;IACZ,kBAAe;IACf,mBAAkB;IAClB,kBAAM;IACN,mBAAS;AN6Of;;AAEA;IM3OM,gBAAU;IAEV,WAAA;IN4OF,aM3Oc;IN4Od,mBM3OU;IN4OV,0DM3OW;IN4OX,mBM3Oa;IN4Ob,kBM3OY;IN4OZ,mBM3OgB;IN4OhB,aM3Oc;IN4Od,kBM3OgB;AN4OpB;;AAEA;IACI,UM3OI;AN4OR;;AAEA;IACI,qBMzOe;IN0Of,UMzOY;IN0OZ,iBMzOiB;AN0OrB;;AAEA;IACI,6BMzOsB;AN0O1B;;AAEA;IACI,eMzOa;IN0Ob,kBMzOY;IN0OZ,gBMzOgB;IN0OhB,cMxOI;ANyOR;;AAEA;IACI,eMxOM;INyON,cMxOgB;INyOhB,gBMvOM;ANwOV;;AAEA;IACI,cMlOgB;ANmOpB;;AAEA;IACI,cM9NgB;AN+NpB;;AAEA;IACI,cM5NgB;AN6NpB;;AAEA;IACI,cMzNe;AN0NnB;;AAEA;IACI,cMzNe;AN0NnB;;AAEA;IM/MI,cAAA;ANiNJ;;AAEA;IM/MM,aAAY;ANiNlB;;AAEA;IM/MM,mBAAkB;IAGpB,oCAAe;IACb,WAAU;IACV,YAAY;IACZ,MAAK;IACL,OAAM;IACN,UAAA;IACA,kBAAa;AN+MnB;;AAEA;IM7MM,mBAAe;IACf,4EAAkB;IAClB,YAAM;IACN,aAAS;IACT,kBAAO;IACP,aAAQ;IACR,mBAAY;IACZ,uBAAU;IAGZ,oBAAA;IACE,eAAa;IAGf,kBAAA;IACE,MAAK;IACL,SAAQ;IAGV,OAAA;IACE,QAAO;IACP,YAAY;IAKd,UAAA;ANqMJ;;AAEA;IACI,kBAAkB;IM/LhB,MAAA;IACA,OAAA;IAGF,SAAA;IN+LA,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,yBM9La;IACX,eAAc;IAGhB,mBAAA;IACE,sBAAY;IACZ,uBAAc;AN6LpB;;AAEA;IM1LM,WAAA;IN4LF,YM3La;IN4Lb,aM3Lc;IN4Ld,uBM3LU;IN4LV,mBM3LW;IN4LX,UM3LY;IN4LZ,kBM3La;IN4Lb,kBM3LkB;IN4LlB,MM3LI;IN4LJ,OM3LI;IN4LJ,SM3LI;IN4LJ,QM3LI;IAIJ,YAAA;ANyLJ;;AAEA;IMrLM,WAAU;IACV,WAAU;IACV,mBAAY;IACZ,kBAAa;IACb,kBAAkB;ANuLxB;;AAEA;IMrLM,wBAAoB;ANuL1B;;AAEA;IMrLM,mBAAS;IACT,UAAO;ANuLb;;AAEA;IMpLM,UAAA;ANsLN;;AAEA;IACI,kBMrLa;INsLb,kBMrLY;INsLZ,UMrLY;ANsLhB;;AAEA;IACI,UMrLI;INsLJ,mBMrLmB;ANsLvB;;AAEA;IMlLM,mBAAA;INoLF,WMnLW;INoLX,YMnLY;INoLZ,kBMnLiB;INoLjB,aMnLI;INoLJ,mBMnLiB;INoLjB,uBMnLc;INoLd,0JMnLsB;INoLtB,kBMnLc;ANoLlB;;AAEA;IACI,mBMnLY;INoLZ,oCMnLgB;INoLhB,WMlLI;INmLJ,YMlLa;INmLb,MMlLM;INmLN,OMlLM;INmLN,UMlLM;INmLN,kBMlLgB;ANmLpB;;AAEA;IACI,mBM5KkB;IN6KlB,4DM5KgB;IAId,YAAA;IN0KF,aMzKc;IN0Kd,kBMxKI;INyKJ,aMxKc;INyKd,mBMxKkB;INyKlB,uBMxKgB;INyKhB,oBMtKI;INuKJ,eMtKgB;INuKhB,kBMtKkB;IAIhB,MAAA;INoKF,SMnKI;INoKJ,OMnKS;INoKT,QMnKU;INoKV,YMnKI;INoKJ,UMnKW;ANoKf;;AAEA;IACI,aMnKc;ANoKlB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBM3JkB;AN4JtB;;AAEA;IMnJI,gBAAA;ANqJJ;;AAEA;;;IM9IM,UAAA;INkJF,kBAAkB;AACtB;;AAEA;;;;;;;IAOI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,yBM3IkB;IAIlB,YAAA;IACE,aAAY;IACZ,kBAAc;ANyIpB;;AAEA;IACI,WMpIE;INqIF,kBMpIiB;IAMnB,MAAA;IACE,OAAM;IACN,QAAO;IACP,oBAAY;IACZ,cAAY;IACZ,UAAA;IACA,WAAU;IACV,mBAAc;IACd,kBAAe;ANgInB;;AAEA;IM3HE,UAAS;IACP,kBAAgB;AN6HpB;;AAEA;IM1HI,mBAAK;IN4HL,4EM3HgB;IAKlB,YAAS;IACP,aAAW;IACX,kBAAY;IACZ,aAAS;IACT,mBAAS;IACT,uBAAkB;IAClB,oBAAkB;IAElB,eAAA;INuHA,kBMtHc;INuHd,MMtHE;INuHF,SMtHQ;INuHR,OMtHE;INuHF,QMtHO;INuHP,YMtHY;INuHZ,UMtHE;ANuHN;;AAEA;IMhHI,kBAAY;IACZ,MAAK;IACL,OAAA;IACA,SAAA;IACA,QAAO;IACP,YAAW;IACX,UAAA;IACA,kBAAc;IACd,cAAW;IACX,yBAAiB;IACjB,eAAa;IACb,mBAAmB;IAGrB,sBAAU;IACR,uBAAW;ANgHf;;AAEA;IM9GI,WAAU;IACV,YAAY;IACZ,aAAY;IACZ,uBAAmB;IAEnB,mBAAA;IN+GA,UM9GS;IAGT,kBAAA;IN6GA,kBM5Ge;IAKjB,MAAA;IACE,OAAO;IACP,SAAA;IACA,QAAQ;IACR,YAAS;ANyGb;;AAEA;IMvGI,WAAU;IAEV,WAAA;INwGA,mBMvGc;IAIhB,kBAAA;IAEE,kBAAgB;ANoGpB;;AAEA;IMhGE,wBAAe;ANkGjB;;AAEA;IM9FI,mBAAa;IACb,UAAA;ANgGJ;;AAEA;IM5FI,UAAO;AN8FX;;AAEA;IM5FI,kBAAe;IAGjB,kBAAe;IACb,UAAO;AN4FX;;AAEA;IM1FI,UAAA;IACA,mBAAa;AN4FjB;;AAEA;IMvFI,mBAAY;IACZ,WAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,aAAY;IACZ,mBAAkB;IAClB,uBAAa;IACb,0JAAmB;IACnB,kBAAiB;ANyFrB;;AAEA;IMrFI,qBAAe;ANuFnB;;AAEA;;;IM9EE,cAAA;ANkFF;;AAEA;;;IM9EI,cAAU;ANkFd;;AAEA;IMhFI,mBAAmB;IACnB,cAAc;ANkFlB;;AAEA;IMxEI,qBAAc;AN0ElB;;AAEA;;;IMpEI,cAAW;ANwEf;;AAEA;;;IMlEI,cAAW;ANsEf;;AAEA;IMpEI,mBAAc;IACd,cAAW;ANsEf;;AAEA;IMpEI,qBAAY;ANsEhB;;AAEA;;;IMhEI,cAAW;ANoEf;;AAEA;;;IM/DI,cAAA;ANmEJ;;AAEA;IACI,mBMlEa;INmEb,cMlEc;ANmElB;;AAEA;IACI,kBM/Dc;ANgElB;;AAEA;IACI,uBM/DoB;INgEpB,8BM/DsB;ANgE1B;;AAEA;IACI,SM/DS;INgET,WM9DE;IN+DF,YM9DW;IN+DX,mBM9DmB;IN+DnB,kBM9DiB;IN+DjB,wDM9De;IN+Df,cM9DI;IN+DJ,eM9DI;IN+DJ,oBM9DkB;IN+DlB,uBM9DmB;IN+DnB,mBM7DI;AN8DR;;AAEA;IACI,gBM1Dc;IAMhB,eAAA;IACE,cAAc;IACd,kBAAe;ANsDnB;;AAEA;IMpDI,cAAY;ANsDhB;;AAEA;IMlDI,WAAW;IACX,YAAW;IAGb,oBAAA;IAEE,SAAA;IACA,6BAAY;IACZ,kBAAe;ANiDnB;;AAEA;IM/CI,YAAS;IACT,kBAAa;IACb,MAAA;IACA,eAAS;IACT,UAAS;IACT,mBAAe;IACf,wBAAiB;ANiDrB;;AAEA;IM5CI,yBAAW;AN8Cf;;AAEA;IM1CE,YAAA;IACE,WAAO;IAGT,sEAAkB;IAChB,mBAAc;IAGhB,aAAA;IACE,mBAAU;IACV,uBAAa;IACb,cAAY;IACZ,eAAe;IACf,iBAAY;IACZ,iBAAU;IACV,mBAAS;ANwCb;;AAEA;IACI,WMtCW;IAIb,aAAA;IACE,sEAAW;IACX,mBAAW;IACX,qCAAmB;IACnB,kBAAY;IACZ,gBAAe;IACf,mBAAkB;ANoCtB;;AAEA;IMhCI,aAAY;ANkChB;;AAEA;IMhCI,aAAa;ANkCjB;;AAEA;IMhCI,aAAQ;IACR,8BAAU;IACV,YAAQ;IAER,eAAA;INiCA,mBM/Bc;INgCd,oBM/Ba;INgCb,WM/BW;INgCX,oBM/Bc;ANgClB;;AAEA;IM3BI,qCAAY;AN6BhB;;AAEA;IM3BI,gBAAY;IACZ,eAAU;IACV,iBAAS;IACT,cAAM;AN6BV;;AAEA;IMvBE,cAAA;IACE,gBAAU;ANyBd;;AAEA;IMvBI,aAAa;IACb,sBAAkB;IAClB,mBAAO;IAGT,kBAAA;ANuBF;;AAEA;IMrBI,cAAY;IACZ,gBAAa;IACb,eAAa;IACb,iBAAiB;IACjB,mBAAkB;ANuBtB;;AAEA;IMrBI,YAAQ;IAER,aAAA;INsBA,sEMpBqB;INqBrB,mBMpBa;INqBb,mBMpBe;INqBf,aMpBU;INqBV,mBMpBiB;INqBjB,uBMpBc;ANqBlB;;AAEA;IMhBI,YAAY;IACZ,aAAa;IACb,0DAAmB;IACnB,kBAAa;IACb,mBAAmB;IACnB,kBAAiB;IAGnB,aAAY;IACV,mBAAY;IACZ,uBAAa;IACb,sBAAmB;ANgBvB;;AAEA;IMVE,iBAAY;IACZ,eAAY;IACZ,iBAAY;ANYd;;AAEA;IMVE,gBAAkB;IAClB,eAAa;IACb,iBAAkB;ANYpB;;AAEA;IMRM,WAAS;IACT,YAAW;IACX,kBAAe;IAKjB,mBAAA;IACE,wDAAqB;IAGvB,kBAAA;IACE,QAAO;IAEP,SAAA;INGF,aMFW;IAOX,mBAAA;IACE,sBAAqB;IAGvB,uBAAA;IACE,oBAAc;IAEd,eAAA;ANNN;;AAEA;IMgBI,cAAA;IACE,eAAc;IAEd,iBAAA;ANfN;;AMsBA;IACE,cAAa;IACb,gBAAW;IACX,eAAY;IACZ,iBAAkB;ANnBpB;;AAEA;IMqBE,aAAa;IACb,mBAAiB;IACjB,uBAAkB;INnBhB,WAAW;IMsBf,YAAA;IACE,mBAAY;IACZ,kBAAa;IACb,cAAa;IACb,eAAiB;IACjB,kBAAmB;IACnB,aAAY;IACZ,UAAU;IACV,wDAAY;IACZ,oBAAU;IACV,eAAe;ANpBjB;;AMwBA;IACE,aAAW;IACX,8BAAY;IACZ,eAAa;IACb,mBAAkB;IAClB,kBAAmB;IACnB,mBAAiB;IACjB,kBAAiB;IACjB,WAAY;ANrBd;;AMyBA;IACE,WAAW;IACX,WAAa;INtBX,mBAAmB;IMyBvB,WAAA;INvBI,4EMwBe;ANvBnB;;AAEA;IACI,WAAW;IMyBf,mBAAkB;IAChB,wDAAkB;IAClB,0BAAU;INvBR,kBAAkB;IO5+BtB,UAAA;IACE,kBAAY;IACZ,oBAAa;IACb,iBAAmB;IACnB,UAAY;IACZ,SAAA;IACA,OAAQ;AP8+BV;;AAEA;IO5+BE,cAAS;IP8+BP,eAAe;IO3+BnB,iBAAa;IACX,WAAY;IACZ,gCAAa;IACb,yBAAY;IACZ,cAAe;IP6+Bb,eAAe;AO1+BnB;;AP6+BA;IO1+BE,gBAAc;AP4+BhB;;AOx+BA;IACE,mBAAmB;IACnB,UAAS;AP2+BX;;AOv+BA;IACE,cAAa;IACb,eAAa;IACb,iBAAmB;IACnB,gBAAkB;IAClB,eAAe;IAEf,oBAAA;APy+BF;;AAEA;IOl+BQ,eAAA;IPo+BJ,iBOn+BgB;IPo+BhB,gCOn+ByB;IAM3B,iBAAA;AP+9BF;;AAEA;IOz9BE,mBAAA;IACE,oHAAmB;IAGrB,mBAAA;IACE,eAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAS;IACT,uBAAuB;IACvB,SAAA;IACA,aAAQ;IAER,eAAA;IPw9BA,iBOv9BY;APw9BhB;;AAEA;IACI,aOv9BU;IAIZ,8BAAgB;IACd,WAAS;IACT,kBAAgB;IAChB,gBAAe;IAGjB,mBAAA;APm9BF;;AAEA;IOj9BI,cAAW;APm9Bf;;AAEA;IO98BA,cAAA;APg9BA;;AAEA;IACI,UAAU;IO78Bd,aAAA;IACE,0EAAW;IACX,mBAAkB;IAClB,mBAAe;IP+8Bb,kBAAkB;IO58BtB,SAAA;IACE,MAAA;IACA,aAAa;AP88Bf;;AAEA;IO58BE,cAAc;AP88BhB;;AAEA;IO38BI,WAAU;IACV,WAAW;IACX,mBAAW;IACX,uCAAY;IACZ,4BAAmB;IACnB,kBAAa;IACb,SAAQ;AP68BZ;;AAEA;IOz8BI,WAAA;IACA,YAAY;IACZ,mBAAW;IP28BX,wDAAwD;IOt8B5D,aAAA;IACE,mBAAmB;IACnB,uBAAW;IACX,kBAAS;IACT,kBAAY;IACZ,QAAA;IACA,UAAS;IACT,eAAU;APw8BZ;;AAEA;IOt8BE,mBAAY;IACZ,WAAA;IACE,aAAU;IACV,YAAY;IPw8BZ,kBAAkB;IOr8BtB,iGAA4B;APu8B5B;;AAEA;IACI,YAAY;IQ9mChB,WAAQ;IACN,sEAAY;IACZ,mBAAgB;IAChB,mBAAY;IACZ,kBAAW;IACX,SAAU;IACV,MAAO;IACP,aAAU;ARgnCZ;;AAEA;IQ7mCI,cAAc;AR+mClB;;AAEA;IQzmCE,UAAA;IACE,YAAW;IACX,mBAAiB;IACjB,uCAAe;IACf,4BAAoB;IAEpB,kBAAA;IR0mCA,OQzmCE;AR0mCN;;AAEA;IQrmCI,WAAW;IACX,YAAW;IACX,mBAAY;IRumCZ,wDAAwD;IQnmC5D,aAAc;IACZ,mBAAa;IACb,uBAAmB;IACnB,kBAAiB;IAEjB,kBAAO;IACL,SAAS;IACT,SAAA;IACA,eAAe;ARomCnB;;AAEA;IQhmCE,mBAAU;IACR,WAAU;IACV,aAAY;IACZ,YAAW;IACX,kBAAY;IACZ,iGAAkB;ARkmCtB;;AAEA;IACI,YAAY;IQ9lChB,aAAM;IACJ,sEAAY;IACZ,mBAAY;IACZ,mBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;ARgmCzB;;AAEA;IQ9lCE,YAAQ;IACR,aAAO;IACL,mBAAmB;ARgmCvB;;AAEA;IQ9lCI,YAAY;IACZ,YAAY;IAEZ,mBAAA;IR+lCA,0DQ9lCsB;IAGtB,mBAAA;IR6lCA,aQ3lCW;IAIb,mBAAA;IAEE,kBAAW;IACX,aAAY;IACZ,kBAAe;IACf,mBAAY;IACZ,eAAU;ARwlCd;;AAEA;IQplCI,YAAO;IAGT,yBAAQ;YAAR,iBAAQ;IACN,eAAQ;ARolCZ;;AAEA;IQhlCI,qBAAkB;ARklCtB;;AAEA;IQ9kCI,cAAW;ARglCf;;AAEA;IQ5kCI,cAAW;AR8kCf;;AAEA;IQ5kCI,qBAAkB;AR8kCtB;;AAEA;IQ3kCI,cAAA;AR6kCJ;;AAEA;IACI,cQ5kCc;AR6kClB;;AAEA;IQxkCE,qBAAgB;AR0kClB;;AQrkCA;IACE,cAAS;ARwkCX;;AAEA;IACI,cAAc;AStuClB;;ATyuCA;IStuCE,aAAY;IACZ,WAAa;IACb,YAAU;IACV,kBAAO;IACL,sEAAW;IACX,eAAY;IAGd,iBAAY;IACV,mBAAQ;IACR,uBAAS;IACT,kBAAkB;ATsuCtB;;AAEA;ISpuCI,YAAS;IACT,aAAY;IACZ,aAAY;ITsuCZ,uBAAuB;ISluCtB,mBAAA;IACH,mBAAW;IACX,kBAAa;IACb,YAAY;IACZ,UAAY;IACZ,kBAAe;IACf,sEAAM;ATouCR;;AAEA;ISluCE,WAAa;IACb,YAAU;IACV,aAAe;IACf,kBAAoB;IAEpB,mBAAO;IACL,uBAAY;IACZ,iBAAK;ITmuCL,mBSluCc;IAEd,0DAAW;ATkuCf;;AAEA;IACI,eShuCa;ITiuCb,iBShuCc;ATiuClB;;AAEA;;IAEI,gBS7tCc;IT8tCd,eS7tCc;IT8tCd,cS7tCc;AT8tClB;;AAEA;ISxtCI,kBAAY;IACZ,UAAS;AT0tCb;;AAEA;ISrtCI,YAAA;ITutCA,aSttCY;IAId,mBAAQ;IACN,uEAAe;IACf,mBAAiB;IACjB,kBAAa;IACb,4BAAoB;IACpB,wBAAc;IACd,YAAY;IACZ,kBAAW;ATotCf;AACA;ISltCI,eAAe;ATotCnB;;;AAGA;IACI,YSjtCS;ITktCT,aShtCE;ITitCF,sEShtCY;IAKZ,mBAAE;AT6sCN;;AAEA;ISzsCI,gBAAA;IT2sCA,eS1sCW;IT2sCX,cS1sCS;IT2sCT,kBS1sCgB;AT2sCpB;;AAEA;IACI,mBS1sCc;IT2sCd,aS1sCY;IT2sCZ,mBS1sCc;AT2sClB;;ASrsCA;IACE,aAAY;ITwsCV,mBAAmB;ISrsCvB,mBAAY;IACV,kBAAmB;IACnB,eAAY;ATusCd;;AAEA;ISrsCE,eAAe;ATusCjB;;AAEA;ISrsCE,aAAY;ATusCd;;AAEA;IS/rCA,UAAA;IACE,mBAAW;ATisCb;;AAEA;IS/rCE,mBAAa;ATisCf;;AAEA;IS/rCE,mBAAe;ATisCjB;;AAEA;IS/rCE,mBAAM;ATisCR;;AAEA;IACI,WAAW;IUx2Cf,YAAM;IACJ,sEAA0B;IAC1B,kBAAgB;IAChB,oBAAkB;IAClB,uBAAmB;IACnB,mBAAa;IACb,eAAW;AV02Cb;;AAEA;IUp2CI,UAAA;IACE,kBAAa;IAIjB,oBAAe;IACb,WAAU;IAEV,YAAA;AVk2CJ;;AAEA;IU71CI,oBAAU;IACV,gBAAQ;IACR,eAAU;AV+1Cd;;AAEA;IU71CI,aAAa;IAGf,mBAAS;IACP,gBAAgB;IAChB,eAAY;IACZ,iBAAS;IACT,cAAY;AV61ChB;;AAEA;IU31CI,YAAU;IAEV,aAAA;IV41CA,yBU31CmB;AV41CvB;;AAEA;IACI,WUv1CE;IAGF,kBAAA;IVs1CA,eUr1Cc;AVs1ClB;;AAEA;IUh1CE,eAAW;IACX,iBAAiB;IACjB,aAAY;IACZ,8BAAU;IACV,mBAAW;IACX,cAAY;IACZ,kBAAmB;AVk1CrB;;AAEA;IUh1CE,WAAa;IACb,kBAAiB;IACjB,WAAY;IAEZ,WAAA;IACE,4EAAW;IACX,mBAAY;IVi1CZ,aAAa;IU30CjB,YAAe;AV60Cf;;AAEA;IU30CE,UAAS;IACT,WAAA;IV60CE,gCAAgC;IU10CpC,+BAAA;IV40CI,wBU30CU;AV40Cd;;AAEA;IU10CE,mBAAmB;IACnB,WAAY;IACZ,sBAAkB;IAClB,gCAAa;IACb,0BAAmB;IACnB,aAAe;IACf,sBAAoB;IACpB,kBAAmB;IAEnB,SAAQ;;IAGV,wBAAqB;AV00CrB;;AAEA;;;GUt0CE;;AV20CF;IUx0CE,cAAgB;IAChB,eAAa;IACb,iBAAkB;AV00CpB;;AAEA;IUx0CE,YAAA;IACA,gBAAA;IACA,4EAAqB;IACrB,WAAa;IV00CX,mBAAmB;IWh9CvB,uBAAO;IACL,kBAAY;IACZ,UAAS;IACT,oBAAgB;AXk9ClB;;AAEA;IWh9CE,mBAAkB;AXk9CpB;;AAEA;IW/8CE,YAAA;IACA,mBAAmB;AXi9CrB;;AAEA;IW/8CE,gBAAa;IACb,iBAAiB;IACjB,eAAc;IACd,oBAAmB;AXi9CrB;;AAEA;IW/8CE,eAAgB;IAChB,iBAAgB;AXi9ClB;;AAEA;IW58CE,aAAA;IACE,iBAAe;IAEf,mBAAA;IX68CA,YW58CS;AX68Cb;;AAEA;IACI,aW58CE;IX68CF,mBAAmB;IWx8CvB,uBAAwB;AX08CxB;;AAEA;IWx8CE,SAAQ;IACR,6BAAkB;IAClB,eAAa;IACb,eAAa;IACb,kBAAiB;IAEjB,cAAA;AXy8CF;;AAEA;IWr8CI,mBAAY;IACZ,+BAAiB;IAGnB,WAAA;IACE,YAAW;IACX,kBAAY;IXq8CZ,kBAAkB;IWj8CtB,SAAA;IACE,WAAY;AXm8Cd;;AAEA;IWj8CE,YAAa;IACb,YAAa;IACb,kBAAiB;IACjB,aAAY;IACZ,mBAAkB;IAElB,uBAAA;IACE,cAAW;IACX,eAAW;IACX,oBAAmB;IACnB,eAAe;AXk8CnB;;AAEA;IACI,mBAAmB;IW57CvB,YAAA;IACE,aAAc;IACd,mBAAgB;IAChB,0DAAe;IACf,sBAAiB;AX87CnB;;AAEA;IACI,oBAAoB;AW37CxB;;AX87CA;IW37CE,aAAa;AX67Cf;;AAEA;IACI,WAAW;IWv7CT,0CAAc;IAGhB,mBAAA;IACE,YAAY;IACZ,UAAO;IAKT,kBAAA;IACE,MAAA;AXm7CN;;AAEA;IW76CI,OAAA;AX+6CJ;;AAEA;IWz6CM,QAAA;AX26CN;;AAEA;IWr6CI,WAAA;IACE,YAAY;IACZ,kBAAc;IAIlB,kBAAA;AXo6CF;;AAEA;IWl6CI,gBAAc;IAGhB,eAAA;IACE,iBAAY;IACZ,eAAa;AXk6CjB;;AAEA;IW55CE,WAAA;IACE,eAAe;IAGjB,mBAAA;IACE,uBAAW;IACX,kBAAY;IACZ,iBAAU;IACV,mBAAW;IACX,aAAW;AX45Cf;;AAEA;IWt5CE,kBAAA;IACE,MAAA;IACA,WAAW;IAGb,YAAA;IACE,WAAU;IACV,sEAAY;IACZ,mBAAO;AXs5CX;;AAEA;IWl5CE,iBAAiB;AXo5CnB;;AAEA;IWj5CE,SAAA;IACE,eAAW;IACX,cAAO;IACP,eAAW;AXm5Cf;;AAEA;IWj5CI,WAAU;IACV,YAAY;IAId,gBAAQ;IACN,mBAAiB;IACjB,kBAAc;AXg5ClB;;AAEA;IW94CI,WAAU;IACV,YAAS;AXg5Cb;;AAEA;IACI,QW94CE;IX+4CF,SW94CQ;IX+4CR,kBW94Cc;IX+4Cd,MW94CE;IX+4CF,OW94CE;IX+4CF,QW94CE;IX+4CF,SW94CQ;IX+4CR,YW94CY;IAGZ,oBAAA;AX64CJ;;AAEA;IACI,WAAW;IWp4Cf,aAAa;IACX,mBAAmB;IACnB,0DAA0D;IAC1D,eAAe;IACf,MAAO;IACP,OAAQ;IACR,aAAe;IAGb,sBAAA;IACE,mBAAmB;IAKrB,UAAA;IACE,mBAAmB;IAIvB,oBAAS;AX63CX;;AAEA;IW33CI,YAAW;AX63Cf;;AAEA;IWz3CI,YAAW;AX23Cf;;AAEA;IWz3CI,aAAa;AX23CjB;;AAEA;IACI,qBWz3CiB;IAInB,WAAA;IACE,YAAW;AXu3Cf;;AAEA;IWr3CI,YAAY;AXu3ChB;;AAEA;IACI,eWr3Ce;IXs3Cf,kBWr3Cc;IAIhB,UAAA;IACE,mBAAkB;IAClB,cAAa;AXm3CjB;;AAEA;IWj3CI,qBAAQ;IACR,YAAY;IAGd,aAAA;IXi3CE,sBAAsB;AAC1B;;AAEA;IW72CI,mBAAY;AX+2ChB;;AAEA;IY7rDA,gBAAA;AZ+rDA;;AAEA;IACI,eAAe;IY5rDnB,qBAAc;IACZ,aAAU;IACV,oBAAM;IACN,cAAO;IACP,oBAAY;IACZ,WAAS;IACT,YAAa;IACb,mBAAY;IACZ,uBAAyB;AZ8rD3B;;AAEA;IYxrDI,mBAAA;IACE,6FAAyB;IAI7B,mBAAQ;IACN,cAAW;AZurDf;;AAEA;IYrrDI,4HAAW;AZurDf;;AAEA;IYrrDI,WAAA;IACA,kBAAc;IACd,UAAA;AZurDJ;;AAEA;IACI,oBYnrDoB;IZorDpB,kBYnrDgB;IZorDhB,kBYnrDiB;IAGjB,iBAAA;IZkrDA,mBYjrDe;IAIjB,YAAA;IACE,yDAAkB;IAClB,UAAO;IACP,kBAAS;IACT,kBAAQ;AZ+qDZ;;AY1qDA;IACE,YAAY;AZ6qDd;;AAEA;IY3qDE,mBAAiB;IACjB,8DAAc;IACd,YAAa;IACb,aAAa;IACb,kBAAiB;IACjB,kBAAgB;IAChB,QAAS;IACT,YAAY;IZ6qDV,iDAAiD;IYzqDrD,oBAAoB;AZ2qDpB;;AAEA;IYzqDE,yBAAY;AZ2qDd;;AAEA;IYzqDE,WAAa;IACb,YAAa;IACb,kBAAiB;IACjB,mBAAW;IACX,aAAa;IACb,mBAAe;IACf,uBAAS;IZ2qDP,wDAAwD;IYvqD5D,eAAmB;IACjB,kBAAmB;IACnB,gBAAkB;IAClB,mBAAa;IACb,MAAA;IZyqDE,SAAS;IYtqDb,UAAA;IACE,oBAAa;AZwqDf;;AAEA;IYrqDI,0BAAQ;IZuqDR,oBAAoB;IYnqDxB,kBAAA;IACE,mBAAkB;IAElB,aAAA;IACE,WAAU;IZoqDV,6BAA6B;AYhqDjC;;AZmqDA;IYhqDE,mBAAgB;AZkqDlB;;AAEA;IACI,aAAa;AY/pDjB;;AZkqDA;IY9pDI,kBAAiB;AZgqDrB;;AAEA;IY5pDE,aAAY;AZ8pDd;;AAEA;IY5pDE,WAAa;IACb,UAAS;IACT,2BAAmB;IACnB,kBAAY;IZ8pDV,YAAY;IY3pDhB,UAAA;IACE,sEAAwB;IACxB,mBAAY;AZ6pDd;;AAEA;IY3pDE,gBAAa;IACb,kBAAe;IACf,4BAAgB;IAChB,YAAc;IZ6pDZ,yBAAyB;IY1pD7B,iBAAA;IAEE,iBAAa;IACb,kBAAmB;AZ2pDrB;;AAEA;IYzpDE,iBAAY;AZ2pDd;;AAEA;IYzpDE,uBAAS;AZ2pDX;;AAEA;IYxpDI,uBAAW;AZ0pDf;;AAEA;IYxpDI,mBAAkB;AZ0pDtB;;AAEA;IYppDA,kBAAA;IACE,WAAY;IACZ,iBAAY;IACZ,YAAY;IACZ,UAAS;IACT,WAAU;IACV,YAAa;IACb,mBAAY;IACZ,wDAAyB;IACzB,kBAAe;IACf,aAAc;IACd,mBAAa;IACb,uBAAmB;IACnB,oBAAiB;AZspDnB;;AAEA;IYppDE,WAAQ;IACR,YAAa;AZspDf;;AAEA;IYlpDE,kBAAY;IACZ,WAAY;IACZ,SAAA;IAEA,aAAA;IAEE,sBAAW;AZkpDf;;AAEA;;IY/oDI,iBAAiB;IAGnB,WAAA;IACE,YAAO;IACP,mBAAY;IACZ,wDAA4B;IAY5B,kBAAkB;IANhB,aAAA;IZ4oDF,mBY3oDc;IZ4oDd,uBY3oDuB;IAOzB,oBAAU;IACR,mBAAc;IACd,eAAa;AZsoDjB;;AAEA;IACI,kBAAkB;IYloDtB,MAAA;IACE,OAAS;IACT,QAAS;IACT,SAAU;IACV,YAAa;IZooDX,kBAAkB;IYjoDtB,mBAAA;IACE,gBAAa;IACb,mBAAqB;IACrB,kBAAgB;IAEhB,iBAAA;IACE,kBAAkB;IAElB,oCAAA;IZioDA,6BYhoDiB;IZioDjB,0BAA0B;IY5nD9B,qBAAA;IZ8nDI,iDY7nD6B;AZ8nDjC;;AY1nDA;IACE,YAAa;IACb,aAAc;IZ6nDZ,gBAAgB;IY1nDpB,YAAA;IACE,sBAAqB;IACrB,mBAAa;IZ4nDX,kBAAkB;AYznDtB;;AZ4nDA;IYznDE,0DAAe;IACf,yBAAiB;IACjB,mBAAc;IACd,YAAY;IACZ,YAAY;IACZ,aAAe;IACf,mBAAe;IACf,qBAAoB;IAEpB,kBAAA;IAEE,mBAAY;IZynDZ,8BAA8B;IYrnDlC,eAAkB;IAChB,cAAY;IACZ,0BAAa;IACb,gBAAkB;IAClB,oBAAa;AZunDf;;AAEA;IACI,4EAA4E;AYlnDhF;;AZqnDA;IYhnDM,eAAY;AZknDlB;;AAEA;IACI,WY/mDM;IZgnDN,YAAY;IYzmDhB,oBAAiB;IACf,cAAgB;IAChB,kBAAe;AZ2mDjB;;AAEA;IYzmDE,mBAAiB;IACjB,4EAAmB;IACnB,WAAY;IACZ,YAAc;IACd,kBAAkB;IZ2mDhB,aAAa;IYxmDjB,mBAAuB;IACrB,uBAAW;AZ0mDb;;AAEA;IYxmDE,WAAa;AZ0mDf;;AAEA;IYvmDI,WAAU;IACV,YAAU;IACV,iBAAS;AZymDb;;AAEA;IYvmDI,WAAA;IACA,YAAW;AZymDf;;AAEA;IYrmDA,mBAAA;IACE,WAAY;IACZ,YAAY;IACZ,kBAAY;IACZ,aAAa;IACb,mBAAkB;IAClB,uBAAkB;IAClB,0JAAa;IACb,kBAAmB;AZumDrB;;AAEA;IYrmDE,WAAY;IACZ,WAAY;IZumDV,mBAAmB;IYpmDvB,kBAAA;IACE,kBAAY;AZsmDd;;AAEA;IYpmDE,wBAA0B;AZsmD5B;;AAEA;IYpmDE,cAAgB;IZsmDd,gBAAgB;IYlmDpB,eAAA;IACE,iBAAc;IACd,gBAAiB;IACjB,mBAAe;IACf,kBAAiB;AZomDnB;;AAEA;IYjmDE,kBAAgB;IAChB,mBAAe;IACf,aAAa;AZmmDf;;AAEA;IYhmDE,qBAAS;AZkmDX;;AAEA;;IY9lDI,cAAU;AZimDd;;AY5lDA;IACE,mBAAkB;IAClB,cAAY;AZ+lDd;;AAEA;IY7lDE,qBAAuB;AZ+lDzB;;AAEA;;IY5lDE,cAAY;AZ+lDd;;AAEA;IY5lDI,mBAAU;IACV,cAAY;AZ8lDhB;;AAEA;IYtlDA,qBAAA;AZwlDA;;AAEA;;IYplDI,cAAc;AZulDlB;;AAEA;IYnlDI,mBAAkB;IAClB,cAAQ;AZqlDZ;;AYhlDA;IACE,YAAY;IACZ,aAAY;IACZ,kBAAmB;IACnB,cAAY;AZmlDd;;AAEA;IYjlDE,YAAa;IACb,aAAY;IZmlDV,kBAAkB;AYhlDtB;;AZmlDA;IYhlDE,eAAgB;AZklDlB;;AAEA;IYhlDE,eAAe;AZklDjB;;AAEA;IY/kDA,WAAA;IACE,YAAa;IACb,UAAA;IACA,WAAW;IACX,WAAa;AZilDf;;AAEA;Ia1kEI,eAAU;IAEV,iBAAA;Ab2kEJ;;AAEA;IarkEI,eAAA;IACE,iBAAc;AbukEpB;;AAEA;IajkEI,UAAA;IACE,YAAA;IAGF,OAAA;AbikEJ;;AAEA;Ia7jEI,aAAA;IACE,qBAAe;IAGjB,8BAAmB;IACjB,kBAAa;IACb,mBAAiB;Ab6jEvB;;AAEA;IazjEM,WAAW;IAGb,wBAAa;IACX,WAAA;IAGF,aAAA;IACE,WAAA;IbujEF,sEAAsE;IaljE1E,kBAAA;IACE,mBAAU;AbojEZ;;AAEA;IaljEE,qBAAa;IACb,cAAe;IACf,gBAAiB;IACjB,eAAY;IACZ,iBAAmB;IACnB,kBAAY;IACZ,aAAe;AbojEjB;;AAEA;IajjEI,WAAU;IACV,QAAO;IbmjEP,oBAAoB;Ia/iExB,WAAA;IACE,mBAAY;IACZ,mEAAY;IACZ,mBAAmB;IACnB,kBAAY;IACZ,aAAY;IACZ,UAAA;AbijEF;;AAEA;IACI,cAAc;Aa7iElB;;AbgjEA;Ia7iEE,WAAA;Ab+iEF;;AAEA;Ia7iEE,mBAAe;IACf,0DAAgB;IAChB,mBAAc;Ib+iEZ,uBAAuB;Ia5iE3B,kBAAA;IACE,mBAAgB;Ab8iElB;;AAEA;Ia5iEE,mBAAY;Ab8iEd;;AAEA;Ia5iEE,mBAAkB;Ab8iEpB;;AAEA;Ia5iEE,cAAS;IACT,gBAAe;IACf,eAAa;Ib8iEX,iBAAiB;Ia1iErB,kBAAA;Ab4iEA;;AAEA;Ia1iEE,gBAAY;IACZ,eAAgB;IAChB,iBAAe;IACf,aAAa;IACb,qBAAa;IACb,mBAAmB;Ab4iErB;;AAEA;Ia1iEE,eAAS;IACT,aAAe;Ib4iEb,oBAAoB;AaxiExB;;Ab2iEA;IaxiEE,WAAa;IACb,WAAY;IACZ,sEAAa;IACb,mBAAmB;IACnB,mBAAiB;Ab0iEnB;;AAEA;IaxiEE,YAAa;IACb,gGAAsB;IACtB,mBAAkB;IAClB,oBAAkB;Ab0iEpB;;AAEA;IaviEE,kBAAK;IACH,iBAAc;IAGhB,gBAAA;IAEE,WAAU;IACV,YAAO;IAEP,QAAA;IbqiEA,YapiES;AbqiEb;;AAEA;;Ia/hEE,iBAAmB;IACnB,eAAY;AbkiEd;;AAEA;IahiEE,YAAc;IACd,SAAW;IACX,UAAU;AbkiEZ;;AAEA;Ia/hEA,kBAAiB;IACf,YAAW;IACX,YAAY;AbiiEd;;AAEA;Ia/hEE,kBAAmB;IACnB,MAAA;IACA,OAAA;IACA,YAAa;IACb,cAAe;IAGf,mBAAA;IACE,wEAAY;IACZ,yBAAkB;IAClB,eAAY;Ab+hEhB;;AAEA;IACI,aAAa;Ac9uEf;;AdivEF;Ic9uEI,yBAAa;AdgvEjB;;AAEA;IACI,ec/uEiB;IdgvEjB,gBc/uEI;IAEF,sBAAA;Id+uEF,kBc9uEc;Id+uEd,Wc9uEY;Id+uEZ,gBc9uEY;IAGZ,aAAA;IACE,mBAAkB;IAEpB,kBAAA;IACE,cAAc;IAEhB,mBAAA;Ad2uEJ;;AAEA;IcxuEM,aAAa;Ad0uEnB;;AAEA;IcvuEM,kBAAiB;IAEnB,cAAA;IACE,mBAAmB;AdwuEzB;;AAEA;Ie5wEE,aAAW;Af8wEb;;AAEA;Ie3wEI,kBAAa;IACb,WAAQ;If6wER,SAAS;IezwEb,0HAAqB;IACnB,WAAS;Af2wEX;;AevwEA;IACE,YAAY;IACZ,YAAU;IACV,mBAAmB;IACnB,mBAAiB;If0wEf,iBAAiB;IevwErB,cAAA;IACE,aAAW;IACX,mBAAa;IACb,uBAAY;IACZ,gBAAkB;IAClB,eAAY;IACZ,sEAAkB;AfywEpB;;AAEA;IevwEE,YAAA;IfywEE,YAAY;IetwEhB,mBAAA;IACE,0EAAY;IACZ,yBAAa;IACb,eAAe;IACf,gBAAkB;IAElB,aAAA;IACE,mBAAW;IACX,uBAAW;IACX,WAAQ;IACR,iBAAU;IACV,eAAM;IACN,SAAO;AfuwEX;;AAEA;IerwEI,mBAAY;IfuwEZ,yBAAyB;IenwE7B,aAAA;IACE,gBAAW;AfqwEb;;AAEA;IenwEE,aAAa;IACb,kBAAkB;AfqwEpB;;AAEA;IelwEA,kBAAkB;IAChB,QAAA;AfowEF;;AAEA;IelwEE,kBAAkB;AfowEpB;;AAEA;IelwEE,kBAAa;AfowEf;;AAEA;IejwEA,kBAAkB;IAChB,eAAY;IACZ,gBAAkB;IAClB,iBAAgB;IAChB,gBAAkB;IAClB,cAAe;AfmwEjB;;AAEA;IehwEE,kBAAiB;AfkwEnB;;Ae9vEA;IACE,iBAAmB;AfiwErB;;AAEA;Ie/vEE,YAAc;IACd,YAAa;IfiwEX,mBAAmB;Ie9vEvB,sEAAwB;IACtB,mBAAe;IACf,kBAAgB;IAChB,aAAe;IACf,mBAAiB;IACjB,YAAc;AfgwEhB;;Ae5vEA;IACE,wBAAoB;IACpB,YAAa;IACb,6BAAsB;IACtB,SAAW;IACX,kBAAiB;IACjB,aAAY;If+vEV,eAAe;Ie5vEnB,gBAAA;IACE,cAAgB;Af8vElB;;AAEA;Ie5vEE,aAAY;IACZ,mBAAmB;If8vEjB,uBAAuB;Ie3vE3B,kBAAA;IACE,mBAAY;IACZ,wDAAY;IACZ,mBAAmB;IACnB,WAAS;IACT,YAAa;IACb,SAAU;IACV,aAAe;IACf,eAAiB;Af6vEnB;;AAEA;Ie3vEE,WAAa;IACb,WAAS;IAET,mBAAA;IACE,kBAAc;If4vEd,kBAAkB;AexvEtB;;Af2vEA;IexvEE,wBAAY;Af0vEd;;AAEA;IexvEE,YAAW;IACX,YAAa;IACb,gBAAS;IACT,cAAe;IACf,kBAAmB;IACnB,mBAAmB;IACnB,wEAAe;IACf,yBAAa;IACb,eAAS;If0vEP,cAAc;IetvElB,aAAa;IACX,mBAAY;IACZ,uBAAa;IACb,SAAU;IACV,eAAe;IACf,aAAY;IACZ,QAAU;IfwvER,gBAAgB;AervEpB;;AfwvEA;IervEE,YAAU;IACV,YAAc;IfuvEZ,mBAAmB;IepvEvB,mBAAoB;AfsvEpB;;AAEA;IepvEE,WAAa;IfsvEX,eAAe;IenvEnB,iBAAA;IACE,aAAW;IACX,mBAAoB;IACpB,uBAAY;AfqvEd;;AAEA;IenvEE,cAAe;IACf,sEAAa;IACb,4BAAmB;IAEnB,kBAAA;AfovEF;;AAEA;Ie/uEI,UAAA;IfivEA,mBehvEgB;AfivEpB;;AAEA;Ie1uEI,cAAY;IAEZ,gBAAA;If2uEA,yBe1uEe;IAGf,sEAAe;IfyuEf,4BexuEgB;AfyuEpB;;AAEA;IACI,aepuEa;IAMb,aAAA;IACE,sEAAW;IACX,+BAAiB;AfguEvB;;AAEA;Ie3tEM,aAAA;If6tEF,qBe5tEmB;IAInB,gBAAA;Af0tEJ;;AAEA;IentEE,kBAAA;AfqtEF;;AAEA;IentEI,eAAa;AfqtEjB;;AAEA;;IejtEI,oBAAA;AfotEJ;;AAEA;Ie/sEI,iBAAe;IACf,kBAAY;AfitEhB;;AAEA;Ie/sEI,qBAAkB;IAClB,aAAa;AfitEjB;;AAEA;Ie/sEI,sBAAiB;IACjB,gBAAa;IAEb,eAAA;IfgtEA,iBe/sEY;IfgtEZ,ce/sEc;IfgtEd,mBe/sEc;IAIhB,kCAAA;IACE,4BAAa;IAKT,eAAA;IfysEJ,oBexsEkB;AfysEtB;;AehsEA;IACE,sEAAsE;AfmsExE;;AAEA;IejsEE,YAAY;IACZ,aAAa;IACb,kBAAiB;IfmsEf,aAAa;IehsEjB,mBAAoB;IAClB,uBAAW;IACX,wDAAY;AfksEd;;AAEA;IehsEE,aAAa;AfksEf;;AAEA;IehsEE,oGAAe;IfksEb,sEAAsE;Ae/rE1E;;AfksEA;Ie/rEE,UAAY;IACZ,mBAAgB;AfisElB;;AAEA;Ie9rEI,gBAAY;IAGd,eAAA;IACE,iBAAY;IAGd,cAAA;IACE,aAAY;If4rEZ,uBAAuB;IexrE3B,mBAAA;IACE,kBAAa;IACb,sBAAsB;IACtB,kBAAmB;Af0rErB;;AAEA;IevrEM,WAAU;IACV,aAAU;IfyrEZ,YAAY;IenrEhB,sEAA+B;IAC7B,kBAAoB;IACpB,kBAAW;AfqrEb;;AAEA;IenrEE,WAAa;IACb,UAAY;IACZ,kBAAkB;IAClB,SAAU;IACV,QAAU;IACV,YAAY;IfqrEV,gCAAgC;IgBzjFlC,+BAAY;IACV,oCAAY;IhB2jFZ,UAAU;IiB7jFd,kBAAA;AjB+jFA;;AAEA;IiB5jFI,mBAAW;IAIf,wDAOC;IANC,YAAK;IACH,aAAW;IAEV,kBAAA;IACD,kBAAW;IAIf,aAAA;IACE,mBAAK;IACH,uBAAuB;IAEtB,UAAA;IACD,UAAS;IAIb,oBAAgB;IACd,kBAAW;AjBmjFb;;AAEA;IiBjjFE,YAAY;IACZ,aAAM;IACN,0DAAO;IACP,kBAAQ;IACR,0BAAS;IACT,aAAU;IjBmjFR,mBAAmB;IiBhjFvB,uBAAY;IACV,sBAAa;AjBkjFf;;AAEA;IiBhjFE,cAAe;IACf,iBAAkB;IAClB,eAAU;IACV,iBAAO;AjBkjFT;;AAEA;IiBhjFE,cAAY;IACZ,gBAAW;IjBkjFT,eAAe;IiB/iFnB,iBAAe;AjBijFf;;AAEA;IiB/iFE,kBAAmB;IACnB,SAAU;IACV,YAAO;IACP,oBAAQ;IACR,sBAAM;AjBijFR;;AAEA;IACI,eAAe;IiB9iFnB,QAAA;AjBgjFA;;AAEA;IiB9iFE,kBAAmB;IACnB,mBAAU;IACV,gCAAO;IACP,mBAAQ;IACR,YAAM;IACN,uBAAS;IACT,YAAY;IACZ,MAAA;IjBgjFE,UAAU;IiB7iFd,UAAc;IACZ,kBAAa;IACb,qDAAc;AjB+iFhB;;AAEA;IiB7iFE,QAAU;IACV,UAAO;IACP,mBAAQ;AjB+iFV;;AAEA;IACI,8BAA8B;AiB5iFlC;;AjB+iFA;IiB5iFE,WAAY;IACZ,kBAAY;IACZ,eAAe;AjB8iFjB;;AAEA;IiB5iFE,cAAS;IACT,eAAQ;IACR,aAAY;AjB8iFd;;AAEA;IiB5iFE,kBAAmB;IACnB,QAAA;IjB8iFE,MAAM;AiB3iFV;;AjB8iFA;IiB3iFE,YAAa;IACb,YAAS;IjB6iFP,mBAAmB;IiB1iFvB,sEAAuB;IACrB,mBAAY;IACZ,kBAAY;IACZ,aAAY;IACZ,mBAAmB;IACnB,YAAY;AjB4iFd;;AAEA;IiBxiFE,WAAA;IACE,YAAW;IACX,6BAA6B;IAC7B,SAAS;IACT,kBAAa;IACb,aAAY;IACZ,eAAe;IACf,gBAAa;IACb,cAAY;AjB0iFhB;;AAEA;IiBniFA,aAAY;IACV,uBAAY;IACZ,WAAY;IACZ,aAAY;AjBqiFd;;AAEA;IiBniFE,gBAAe;IACf,kBAAa;AjBqiFf;;AAEA;IiBniFE,mBAAe;AjBqiFjB;;AAEA;IiBjiFA,6BAAkB;AjBmiFlB;;AAEA;IiBjiFE,cAAa;AjBmiFf;;AAEA;IACI,cAAc;IiBhiFlB,iBAAgB;AjBkiFhB;;AAEA;IiBhiFE,iBAAmB;AjBkiFrB;;AAEA;IiBhiFE,gBAAY;IACZ,oBAAW;IACX,mBAAY;AjBkiFd;;AAEA;IiB/hFE,eAAA;AjBiiFF;;AAEA;IiB7hFA,mBAAuB;IACrB,uBAAkB;AjB+hFpB;;AAEA;IiB7hFE,kBAAmB;IjB+hFjB,SAAS;IkBzuFb,WAAA;AlB2uFA;;AAEA;ImB7uFA,kBAAQ;AnB+uFR;;AAEA;IACI,mBAAmB;AACvB;;AAEA;ImB3uFE,UAAS;IAET,kBAAA;InB4uFE,kBmB1uFe;InB2uFf,YAAY;ImBvuFhB,aAAM;IACJ,eAAW;IACX,8BAAa;IACb,YAAY;IACZ,mBAAmB;InByuFjB,oCAAoC;ImBtuFxC,mBAAsB;IACpB,UAAS;InBwuFP,4BAA4B;AAChC;;AAEA;ImBpuFA,mBAAmB;IACjB,UAAO;AnBsuFT;;AAEA;IACI,YAAY;ImBnuFd,YAAW;IACX,mBAAY;InBquFV,sEAAsE;ImBluF1E,mBAAA;IACE,kBAAe;IACf,aAAa;InBouFX,mBAAmB;ImBjuFvB,YAAA;AnBmuFA;;AAEA;ImBhuFE,WAAW;IACX,YAAY;IACZ,6BAAe;InBkuFb,SAAS;ImB/tFb,kBAAM;IACJ,aAAa;IACb,eAAe;InBiuFb,gBAAgB;ImB9tFpB,cAAa;AnBguFb;;AAEA;IACI,gBAAgB;ImB7tFpB,eAAa;IACX,iBAAe;InB+tFb,YAAY;ImB5tFhB,YAAY;IACV,cAAa;InB8tFX,mBAAmB;ImB3tFvB,wEAA0B;IACxB,yBAAmB;InB6tFjB,aAAa;ImB1tFjB,mBAAa;IACX,uBAAW;IACX,SAAQ;InB4tFN,eAAe;ImBztFnB,aAAA;AnB2tFA;;AAEA;ImBxtFE,WAAQ;InB0tFN,YAAY;ImBvtFhB,mBAAoB;IAClB,0EAAS;IACT,yBAAU;InBytFR,eAAe;ImBttFnB,gBAAA;IACE,aAAW;IACX,mBAAiB;InBwtFf,uBAAuB;ImBrtF3B,WAAA;IACE,eAAU;IACV,SAAQ;InButFN,eAAe;AACnB;;AAEA;ImBptFE,WAAU;InBstFR,YAAY;ImBntFhB,kBAAkB;IAChB,mBAAa;InBqtFX,aAAa;ImBltFjB,mBAAmB;IACjB,uBAAe;InBotFb,wDAAwD;ImBjtF5D,cAAA;IACE,eAAW;IACX,iBAAY;IACZ,sBAAmB;InBmtFjB,kBAAkB;ImBhtFtB,kBAAe;IACb,YAAW;IACX,aAAS;InBktFP,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;ImB7sFrB,gCAAmB;IACjB,eAAe;AnB+sFjB;;AAEA;ImB5sFA,gCAA6B;AnB8sF7B;;AAEA;ImB3sFA,WAAA;IACE,eAAW;IACX,mBAAY;InB6sFV,sEAAsE;ImB1sF1E,mBAAA;IACE,aAAW;InB4sFT,uBAAuB;ImBzsF3B,sBAAsB;IACpB,mBAAe;IACf,kBAAiB;IACjB,WAAA;IACA,SAAA;AnB2sFF;;AAEA;ImBvsFE,WAAO;IACP,YAAS;IACT,aAAa;InBysFX,mBAAmB;ImBtsFvB,uBAAY;IACV,mBAAY;IACZ,wDAAU;IACV,kBAAS;InBwsFP,mBAAmB;ImBrsFvB,eAAO;AnBusFP;;AAEA;ImBpsFA,YAAA;IACE,kBAAY;IACZ,iBAAY;IACZ,6BAAmB;AnBssFrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;ImBlsFrB,kBAAA;AnBosFA;;AAEA;ImBjsFA,mBAAS;IACP,kBAAiB;AnBmsFnB;;AAEA;ImBhsFE,mBAAO;IACP,uBAAiB;AnBksFnB;;AAEA;ImB/rFE,kBAAW;InBisFT,QAAQ;ImB9rFZ,QAAA;AnBgsFA;;AAEA;ImB7rFA,6BAAA;AnB+rFA;;AAEA;ImB5rFA,cAAA;AnB8rFA;;AAEA;ImB3rFE,cAAa;IACb,iBAAe;AnB6rFjB;;AAEA;ImBxrFE,gBAAA;InB0rFE,oBmBzrFY;InB0rFZ,mBmBzrFa;AnB0rFjB;;AAEA;IACI,iBmBvrFY;AnBwrFhB;;AAEA;IACI,mBmBrrFiB;AnBsrFrB;;AAEA;ImBlrFE,YAAA;IACA,WAAW;InBorFT,gBAAgB;AACpB;;AAEA;ImB/qFA,WAAa;IACX,oBAAkB;IAClB,YAAA;AnBirFF;;AAEA;IACI,6BmB/qFM;IAGR,YAAA;AnB8qFF;;AAEA;IACI,YmB3qFO;InB4qFP,kBmB3qFW;InB4qFX,mBAAmB;ImBpqFvB,iBAAA;AnBsqFA;;AAEA;ImBnqFE,WAAA;IACA,aAAY;InBqqFV,yEAAyE;ImBlqF7E,kBAAS;IACP,0DAAW;IACX,kBAAY;IACZ,UAAO;InBoqFL,aAAa;ImBjqFjB,mBAAe;IACb,uBAAW;AnBmqFb;;AAEA;IACI,YAAY;ImBhqFd,aAAW;IACX,kBAAY;IACZ,kBAAe;AnBkqFjB;;AAEA;ImB5pFE,WAAA;IACE,WAAU;InB8pFV,YAAY;ImBzpFhB,kBAAA;IACE,MAAA;IACA,OAAA;InB2pFE,kBAAkB;ImBxpFtB,0DAAA;InB0pFI,UAAU;ImBxpFZ,uIAAe;AnB0pFjB;;AAEA;ImBvpFE,WAAQ;InBypFN,mBAAmB;ImBtpFvB,0DAAuC;IACrC,mBAAe;IACf,kBAAY;InBwpFV,kBAAkB;ImBrpFtB,aAAA;IACE,sBAAY;AnBupFd;;AAEA;ImBppFE,gBAAc;IACd,eAAS;InBspFP,iBAAiB;ImBnpFrB,cAAiB;IACf,kBAAW;IACX,mEAAY;IACZ,gBAAe;InBqpFb,YAAY;ImBlpFhB,aAAA;IACE,mBAAY;IACZ,uBAAW;AnBopFb;;AAEA;ImBjpFE,mEAAa;IACb,kBAAc;InBmpFZ,gBAAgB;ImBhpFpB,kBAAgB;IACd,mBAAY;AnBkpFd;;AAEA;ImB7oFI,eAAe;IAGjB,iBAAA;IACE,cAAY;AnB6oFhB;;AAEA;ImBzoFE,mBAAQ;InB2oFN,8DAA8D;ImBxoFlE,mBAAe;IACb,gBAAO;IACP,kBAAQ;InB0oFN,mBAAmB;AACvB;;AAEA;IACI,eAAe;ImBtoFnB,gBAAc;IACZ,eAAO;IACP,iBAAQ;InBwoFN,cAAc;ImBroFlB,kBAAa;AnBuoFb;;AAEA;ImBpoFA,oBAAuB;IACrB,aAAY;IACZ,sBAAY;InBsoFV,mBAAmB;ImBnoFvB,uBAAY;IACV,mEAAY;AnBqoFd;;AAEA;IACI,gBAAgB;ImBjoFpB,eAAA;InBmoFI,iBAAiB;ImBjoFnB,cAAY;IACZ,kBAAa;InBmoFX,mBAAmB;AACvB;;AAEA;ImBhoFE,YAAY;InBkoFV,YAAY;ImB/nFhB,mBAAA;InBioFI,SAAS;ImB/nFX,mBAAe;InBioFb,kBAAkB;ImB9nFtB,eAAA;InBgoFI,iBAAiB;ImB9nFnB,gBAAW;IACX,aAAW;InBgoFT,sEAAsE;ImB7nF1E,mBAAA;InB+nFI,oBAAoB;AACxB;;AAEA;ImB3nFE,cAAW;AnB6nFb;;AAEA;ImB1nFE,YAAS;IACT,YAAS;InB4nFP,0DAA0D;ImBznF9D,mBAAY;IACV,cAAW;IACX,gBAAY;IACZ,eAAY;InB2nFV,eAAe;ImBxnFnB,oBAAiB;IACf,uBAAW;IACX,mBAAY;InB0nFV,mBAAmB;ImBvnFvB,eAAkB;IAChB,aAAW;IACX,SAAQ;AnBynFV;;AAEA;ImBtnFE,YAAQ;InBwnFN,aAAa;ImBrnFjB,sEAAqB;IACnB,mBAAW;IACX,YAAY;InBunFV,gBAAgB;AACpB;;AAEA;ImBnnFA,WAAA;InBqnFI,YAAY;ImBnnFd,oBAAe;InBqnFb,kBAAkB;AACtB;;AAEA;ImBlnFE,YAAA;IACA,aAAY;IACZ,sBAAkB;InBonFhB,qBAAqB;AACzB;;AAEA;ImBjnFE,WAAO;InBmnFL,oBAAoB;ImBhnFxB,YAAA;IACE,mBAAkB;IAClB,mBAAW;IACX,sEAAY;InBknFV,mBAAmB;ImB/mFvB,aAAA;IACE,mBAAe;AnBinFjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,sEAAsE;IACtE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,sEAAsE;IACtE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wDAAwD;IACxD,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,sEAAsE;IACtE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AA6BA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,uDAAuD;AAC3D;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,UAAU;IACV,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8DAA8D;IAC9D,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,sEAAsE;IACtE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,0DAA0D;IAC1D,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8DAA8D;IAC9D,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,yBAAyB;QACzB,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,4BAA4B;QAC5B,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,MAAM;IACV;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,YAAY;QACZ,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,WAAW;IACf;;IAEA;;QAEI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
